import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import purify from 'dompurify';
import require$$0$3 from 'util';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var ReportingUrlValues;
(function (ReportingUrlValues) {
    ReportingUrlValues["VERIFICATION_MODAL"] = "/customer-verification/verification/modal";
})(ReportingUrlValues || (ReportingUrlValues = {}));
var FriendlyPageNameValues;
(function (FriendlyPageNameValues) {
    FriendlyPageNameValues["VERIFICATION_MODAL"] = "FN New Customer Verification Modal Pg";
})(FriendlyPageNameValues || (FriendlyPageNameValues = {}));
var EventLabels;
(function (EventLabels) {
    EventLabels["NEW_CUSTOMER"] = "New Customer";
    EventLabels["SYSTEM_ERROR"] = "System Error";
    EventLabels["EXISTING_CUSTOMER"] = "Existing Customer";
})(EventLabels || (EventLabels = {}));
var ErrorTypes;
(function (ErrorTypes) {
    ErrorTypes["SUCCESS_ADMIT"] = "Success_Admit";
    ErrorTypes["FAILURE_DATA"] = "Failure_Data";
})(ErrorTypes || (ErrorTypes = {}));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var verificationSimpleModelSize = "CustomerVerification-module_verificationSimpleModelSize__2mgaL";
var firstNetImg = "CustomerVerification-module_firstNetImg__qHvIR";
var verificationModalHeading = "CustomerVerification-module_verification-modal-heading__Tpkmf";
var verificationModalSubHeading = "CustomerVerification-module_verificationModalSubHeading__11-FT";
var verificationModalContent = "CustomerVerification-module_verification-modal-content__3Gqbn";
var verificationCtaClass = "CustomerVerification-module_verification-cta-class__1DBTH";
var verificationCancelCtaClass = "CustomerVerification-module_verification-cancel-cta-class__RqnM8";
var textField = "CustomerVerification-module_textField__pW1oV";
var label = "CustomerVerification-module_label__FNUfL";
var alertIcon = "CustomerVerification-module_alertIcon__1iSEx";
var systemalertIcon = "CustomerVerification-module_systemalertIcon__3-kPf";
var css_248z$8 = "@media (max-width: 425px) {\n  .CustomerVerification-module_verificationSimpleModelSize__2mgaL {\n    max-width: 326px; } }\n\n@media (min-width: 426px) and (max-width: 1024px) {\n  .CustomerVerification-module_verificationSimpleModelSize__2mgaL {\n    /*max-width: 435px;*/ } }\n\n@media (min-width: 1025px) {\n  .CustomerVerification-module_verificationSimpleModelSize__2mgaL {\n    max-width: 600px; } }\n\n.CustomerVerification-module_firstNetImg__qHvIR {\n  max-width: 130px; }\n\n.CustomerVerification-module_verification-modal-heading__Tpkmf {\n  padding: 2px 0;\n  margin-bottom: 4px;\n  text-align: center; }\n  @media (max-width: 425px) {\n    .CustomerVerification-module_verification-modal-heading__Tpkmf {\n      font-size: 22px;\n      font-weight: 700; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .CustomerVerification-module_verification-modal-heading__Tpkmf {\n      font-size: 28px;\n      font-weight: 700; } }\n  @media (min-width: 1025px) {\n    .CustomerVerification-module_verification-modal-heading__Tpkmf {\n      font-size: 24px;\n      font-weight: 700; } }\n\n.CustomerVerification-module_verificationModalSubHeading__11-FT {\n  color: #1d2329;\n  font-weight: 700; }\n  @media (max-width: 425px) {\n    .CustomerVerification-module_verificationModalSubHeading__11-FT {\n      padding-top: 16px;\n      padding-bottom: 6px;\n      font-size: 16px;\n      line-height: 18px; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .CustomerVerification-module_verificationModalSubHeading__11-FT {\n      padding-top: 16px;\n      padding-bottom: 4px;\n      font-size: 18px;\n      line-height: 21px; } }\n  @media (min-width: 1025px) {\n    .CustomerVerification-module_verificationModalSubHeading__11-FT {\n      padding-top: 24px;\n      padding-bottom: 2px;\n      font-size: 20px;\n      line-height: 23px; } }\n\n.CustomerVerification-module_verification-modal-content__3Gqbn {\n  width: 100%;\n  text-align: justify; }\n  .CustomerVerification-module_verification-modal-content__3Gqbn p {\n    font-weight: 400; }\n    .CustomerVerification-module_verification-modal-content__3Gqbn p span {\n      margin-top: 24px;\n      font-weight: 700; }\n      @media (min-width: 1025px) {\n        .CustomerVerification-module_verification-modal-content__3Gqbn p span {\n          font-size: 24px; } }\n      @media (min-width: 426px) and (max-width: 1024px) {\n        .CustomerVerification-module_verification-modal-content__3Gqbn p span {\n          font-size: 18px; } }\n      @media (max-width: 425px) {\n        .CustomerVerification-module_verification-modal-content__3Gqbn p span {\n          font-size: 15px;\n          margin-top: 10px; } }\n    @media (min-width: 1025px) {\n      .CustomerVerification-module_verification-modal-content__3Gqbn p {\n        font-size: 15px; } }\n    @media (max-width: 425px) {\n      .CustomerVerification-module_verification-modal-content__3Gqbn p {\n        font-size: 14px; } }\n\n.CustomerVerification-module_verification-cta-class__1DBTH {\n  font-size: 14px;\n  width: 100%;\n  font-weight: 500;\n  border-radius: 48px;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  padding-left: 24px;\n  padding-right: 24px; }\n\n.CustomerVerification-module_verification-cancel-cta-class__RqnM8 {\n  color: #166dde;\n  font-weight: 500;\n  font-size: 15px;\n  margin-top: 13px;\n  text-align: center !important;\n  width: -webkit-fit-content !important;\n  width: -moz-fit-content !important;\n  width: fit-content !important; }\n  @media (min-width: 1025px) {\n    .CustomerVerification-module_verification-cancel-cta-class__RqnM8 {\n      float: none !important;\n      width: -webkit-fit-content !important;\n      width: -moz-fit-content !important;\n      width: fit-content !important; } }\n\n.CustomerVerification-module_verfication-alert-svg__1okMb {\n  height: 24px;\n  width: 24px;\n  min-width: 24px; }\n\n@media (max-width: 375px) {\n  .CustomerVerification-module_verification-simple-model__DUZ9y {\n    margin: 0;\n    max-height: 100vh; } }\n\n@media (min-width: 1025px) {\n  .CustomerVerification-module_text-center__U1Er8 {\n    width: 503px; } }\n\n.CustomerVerification-module_firstNetLabel__izgs7 {\n  font-weight: 700px;\n  font-size: 14px;\n  padding-bottom: 8px;\n  color: #454b52;\n  margin-bottom: 8px; }\n  @media (max-width: 425px) {\n    .CustomerVerification-module_firstNetLabel__izgs7 {\n      padding-top: 22px; } }\n  @media (min-width: 426px) and (max-width: 1024px) {\n    .CustomerVerification-module_firstNetLabel__izgs7 {\n      padding-top: 18px; } }\n  @media (min-width: 1025px) {\n    .CustomerVerification-module_firstNetLabel__izgs7 {\n      padding-top: 18px; } }\n\n.CustomerVerification-module_lastNameLabel__wnRrW {\n  font-size: 14px;\n  color: #454b52;\n  font-weight: 700px;\n  padding-top: 16px;\n  padding-bottom: 8px;\n  margin-bottom: 8px; }\n\n.CustomerVerification-module_textField__pW1oV div input {\n  -webkit-appearance: none !important;\n     -moz-appearance: none !important;\n          appearance: none !important;\n  background-color: #fff !important;\n  border: 1px solid #686e74 !important;\n  border-radius: 0.3rem !important;\n  color: #1d2329 !important;\n  display: flex !important;\n  font-family: font-regular,sans-serif !important;\n  font-size: 1.6rem !important;\n  width: 100% !important;\n  min-height: 48px !important;\n  line-height: normal !important;\n  padding-left: 16px !important;\n  padding-right: 24px !important; }\n\n.CustomerVerification-module_textField__pW1oV div div {\n  color: #c70032 !important; }\n  .CustomerVerification-module_textField__pW1oV div div label {\n    color: black !important;\n    font-family: font-bold !important; }\n\n.CustomerVerification-module_label__FNUfL div div label {\n  text-align: left !important;\n  color: black !important; }\n\n.CustomerVerification-module_alertIcon__1iSEx div {\n  background-color: #f3f4f6 !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n  padding-left: 0px !important;\n  padding-right: 12px !important; }\n  .CustomerVerification-module_alertIcon__1iSEx div div p {\n    color: #1d2329 !important;\n    font-size: 1.2rem !important;\n    font-family: font-bold, sans-serif !important; }\n    @media (max-width: 425px) {\n      .CustomerVerification-module_alertIcon__1iSEx div div p {\n        margin-top: 12px !important; } }\n    @media (min-width: 426px) and (max-width: 1024px) {\n      .CustomerVerification-module_alertIcon__1iSEx div div p {\n        margin-top: 12px !important; } }\n    @media (min-width: 1025px) {\n      .CustomerVerification-module_alertIcon__1iSEx div div p {\n        margin-top: 10px !important; } }\n  .CustomerVerification-module_alertIcon__1iSEx div div svg {\n    color: orange !important; }\n    @media (max-width: 425px) {\n      .CustomerVerification-module_alertIcon__1iSEx div div svg {\n        margin-top: 12px !important;\n        margin-left: 12px !important; } }\n    @media (min-width: 426px) and (max-width: 1024px) {\n      .CustomerVerification-module_alertIcon__1iSEx div div svg {\n        margin-top: 8px !important;\n        margin-left: 12px !important; } }\n    @media (min-width: 1025px) {\n      .CustomerVerification-module_alertIcon__1iSEx div div svg {\n        margin-top: 8px !important;\n        margin-left: 12px !important; } }\n\n.CustomerVerification-module_systemalertIcon__3-kPf div {\n  background-color: #f3f4f6 !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n  padding-left: 0px !important;\n  padding-right: 12px !important; }\n  .CustomerVerification-module_systemalertIcon__3-kPf div div p {\n    color: #1d2329 !important;\n    font-size: 1.2rem !important;\n    font-family: font-bold, sans-serif !important; }\n    @media (max-width: 425px) {\n      .CustomerVerification-module_systemalertIcon__3-kPf div div p {\n        margin-top: 8px !important; } }\n    @media (min-width: 426px) and (max-width: 1024px) {\n      .CustomerVerification-module_systemalertIcon__3-kPf div div p {\n        margin-top: 8px !important; } }\n    @media (min-width: 1025px) {\n      .CustomerVerification-module_systemalertIcon__3-kPf div div p {\n        margin-top: 8px !important; } }\n  .CustomerVerification-module_systemalertIcon__3-kPf div div svg {\n    color: orange !important; }\n    @media (min-width: 1025px) {\n      .CustomerVerification-module_systemalertIcon__3-kPf div div svg {\n        margin-top: 12px !important;\n        margin-left: 12px !important; } }\n    @media (min-width: 426px) and (max-width: 1024px) {\n      .CustomerVerification-module_systemalertIcon__3-kPf div div svg {\n        margin-top: 12px !important;\n        margin-left: 12px !important; } }\n    @media (max-width: 425px) {\n      .CustomerVerification-module_systemalertIcon__3-kPf div div svg {\n        margin-top: 12px !important;\n        margin-left: 12px !important; } }\n";
styleInject(css_248z$8);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
		path: basedir,
		exports: {},
		require: function (path, base) {
			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
		}
	}, fn(module, module.exports), module.exports;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var Simplify = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.simplify = void 0;
/**
 * Turns all optional values in an object to the value itself if it is truthy, or undefined if not.
 * @param obj The object to simplify.
 */
function simplify(obj) {
    var except = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        except[_i - 1] = arguments[_i];
    }
    var ret = {};
    // tslint:disable-next-line: forin
    for (var key in obj) {
        if (except.includes && except.includes(key)) {
            continue;
        }
        ret[key] = obj[key] || undefined;
    }
    return ret;
}
exports.simplify = simplify;
});

var baseCta = "BaseCta_base-cta__Dkwgk";
var googlePlayLg = "BaseCta_google-play-lg__37_PA";
var googlePlaySm = "BaseCta_google-play-sm__2PzO7";
var appleAppStoreLg = "BaseCta_apple-app-store-lg__yJv3U";
var appleAppStoreSm = "BaseCta_apple-app-store-sm__VKhgZ";
var css_248z$7 = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.BaseCta_base-cta__Dkwgk {\n  background: none;\n  border: none; }\n  body.is-tabbing .BaseCta_base-cta__Dkwgk:focus {\n    outline: 2px solid #0057b8; }\n\na.BaseCta_google-play-lg__37_PA, a.BaseCta_google-play-sm__2PzO7 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_apple-app-store-lg__yJv3U, a.BaseCta_apple-app-store-sm__VKhgZ {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_google-play-lg__37_PA, a.BaseCta_apple-app-store-lg__yJv3U {\n  height: 48px;\n  width: 162px; }\n\na.BaseCta_google-play-sm__2PzO7, a.BaseCta_apple-app-store-sm__VKhgZ {\n  height: 32px;\n  width: 108px; }\n";
var BaseCta$2 = {"base-cta":"BaseCta_base-cta__Dkwgk","google-play-lg":"BaseCta_google-play-lg__37_PA","google-play-sm":"BaseCta_google-play-sm__2PzO7","apple-app-store-lg":"BaseCta_apple-app-store-lg__yJv3U","apple-app-store-sm":"BaseCta_apple-app-store-sm__VKhgZ","baseCta":"BaseCta_base-cta__Dkwgk","googlePlayLg":"BaseCta_google-play-lg__37_PA","googlePlaySm":"BaseCta_google-play-sm__2PzO7","appleAppStoreLg":"BaseCta_apple-app-store-lg__yJv3U","appleAppStoreSm":"BaseCta_apple-app-store-sm__VKhgZ"};
var stylesheet$4="/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.BaseCta_base-cta__Dkwgk {\n  background: none;\n  border: none; }\n  body.is-tabbing .BaseCta_base-cta__Dkwgk:focus {\n    outline: 2px solid #0057b8; }\n\na.BaseCta_google-play-lg__37_PA, a.BaseCta_google-play-sm__2PzO7 {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_apple-app-store-lg__yJv3U, a.BaseCta_apple-app-store-sm__VKhgZ {\n  background-image: url(\"data:image/svg+xml;base64,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\"); }\n\na.BaseCta_google-play-lg__37_PA, a.BaseCta_apple-app-store-lg__yJv3U {\n  height: 48px;\n  width: 162px; }\n\na.BaseCta_google-play-sm__2PzO7, a.BaseCta_apple-app-store-sm__VKhgZ {\n  height: 32px;\n  width: 108px; }\n";
styleInject(css_248z$7);

var BaseCta$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    baseCta: baseCta,
    googlePlayLg: googlePlayLg,
    googlePlaySm: googlePlaySm,
    appleAppStoreLg: appleAppStoreLg,
    appleAppStoreSm: appleAppStoreSm,
    'default': BaseCta$2,
    stylesheet: stylesheet$4
});

var BaseCtaProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = void 0;
(function (Classes) {
    Classes["onDark"] = "on-dark";
    Classes["disabled"] = "disabled";
})(exports.Classes || (exports.Classes = {}));
});

var utils = createCommonjsModule(function (module, exports) {
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (commonjsGlobal && commonjsGlobal.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeSsrSafe = exports.ssrSafe = exports.isMobile = void 0;
/**
 * @param {string} parentTestId testId of parent component
 * @param {string} component Callee component's definition. Ex: Button
 * @param {string} testIdSuffix Describes callee component's feature/property. Ex: SelectPrice
 */
function getTestId(parentTestId, component, testIdSuffix) {
    return parentTestId
        ? parentTestId + "_" + component + (testIdSuffix ? "_" + testIdSuffix : "")
        : "";
}
exports.default = getTestId;
function isMobile() {
    if (process.browser) {
        return /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    return false;
}
exports.isMobile = isMobile;
/**
 * Run a function if it is safe to do so when taking SSR into account.
 * @param func The function to run if it is safe to do so.
 * @param dependencies Any extra dependencies to check.
 */
function ssrSafe(func, dependencies) {
    if (dependencies === void 0) { dependencies = [
        (typeof process === "object" && process.browser) || typeof window === "object",
    ]; }
    // ensures browser specific functions are run only if browser is available whether in ssr or client
    if (dependencies.every(Boolean)) {
        return func();
    }
    return undefined;
}
exports.ssrSafe = ssrSafe;
function makeSsrSafe(func, dependencies) {
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return ssrSafe(function () {
            var _a;
            return (_a = func).call.apply(_a, __spread([_this], args));
        }, dependencies);
    };
}
exports.makeSsrSafe = makeSsrSafe;
});

var Breakpoint = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDesktop = exports.isTablet = exports.isMobile = void 0;

var breakpoints = {
    mobile: [0, 639],
    tablet: [640, 1028],
    desktop: [1029, Infinity],
};
function checkBounds(n, range, orientation) {
    var mid = Math.round((range[1] - range[0]) / 2);
    return !orientation
        ? range[0] <= n && n <= range[1]
        : orientation === "portrait"
            ? checkBounds(n, [range[0], mid])
            : checkBounds(n, [mid + 1, range[1]]);
}
exports.isMobile = utils.makeSsrSafe(function (orientation) {
    return checkBounds(window.innerWidth, breakpoints.mobile, orientation);
});
exports.isTablet = utils.makeSsrSafe(function (orientation) {
    return checkBounds(window.innerWidth, breakpoints.tablet, orientation);
});
exports.isDesktop = utils.makeSsrSafe(function () {
    return checkBounds(window.innerWidth, breakpoints.desktop);
});
});

var Constants = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Font = exports.Type = exports.tilePaddingBottom = exports.standardGutter = exports.tilePaddingTop = exports.tileSpacing = exports.focusableSelector = exports.tileSpacingNotMobile = exports.tileSpacingMobile = exports.tilePaddingTopNotMobile = exports.tilePaddingTopMobile = exports.tilePaddingHorizontal = exports.tilePaddingBottomNotMobile = exports.tilePaddingBottomMobile = exports.tileHorizontalMarginNotMobile = exports.tileHorizontalMarginMobile = exports.standardGutterNotMobile = exports.standardGutterMobile = exports.maxWidth = void 0;

/** The max width of the content grid. */
exports.maxWidth = 1252;
/** The gutter from the content to the screen edge when on a mobile device. */
exports.standardGutterMobile = 24;
/** The gutter from the content to the screen edge when on a non-mobile device. */
exports.standardGutterNotMobile = 32;
/** The margin from the tile to the screen edge when on a mobile device. */
exports.tileHorizontalMarginMobile = 0;
/** The margin from the tile to the screen edge when on a non-mobile device. */
exports.tileHorizontalMarginNotMobile = 32;
/** The standard bottom padding for a tile when on a mobile device. */
exports.tilePaddingBottomMobile = 16;
/** The standard bottom padding for a tile when on a non-mobile device. */
exports.tilePaddingBottomNotMobile = 24;
/** The standard horizontal padding for a tile on any device. */
exports.tilePaddingHorizontal = 24;
/** The standard top padding for a tile when on a mobile device. */
exports.tilePaddingTopMobile = 24;
/** The standard top padding for a tile when on a non-mobile device. */
exports.tilePaddingTopNotMobile = 32;
/** The spacing between tiles when on a mobile device. */
exports.tileSpacingMobile = 16;
/** The spacing between tiles when on a non-mobile device. */
exports.tileSpacingNotMobile = 32;
/** A selector that will match elements that can be focused. */
exports.focusableSelector = 'a:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'area:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'button:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'input:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'object:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'select:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    'textarea:not([tabindex^="-"]):not([tabindex=""]):not([disabled]),' +
    '[tabindex]:not([tabindex^="-"]):not([tabindex=""])';
exports.tileSpacing = function () { return (Breakpoint.isMobile() ? exports.tileSpacingMobile : exports.tileSpacingNotMobile); };
exports.tilePaddingTop = function () { return (Breakpoint.isMobile() ? exports.tilePaddingTopMobile : exports.tilePaddingTopNotMobile); };
exports.standardGutter = function () { return (Breakpoint.isMobile() ? exports.standardGutterMobile : exports.standardGutterNotMobile); };
exports.tilePaddingBottom = function () {
    return Breakpoint.isMobile() ? exports.tilePaddingBottomMobile : exports.tilePaddingBottomNotMobile;
};
(function (Type) {
    Type["xxxl"] = "type-2-xxxl";
    Type["xxl"] = "type-2-xxl";
    Type["xl"] = "type-2-xl";
    Type["lg"] = "type-2-lg";
    Type["md"] = "type-2-md line-h-md";
    Type["base"] = "type-2-base line-h-lg";
    Type["sm"] = "type-2-sm line-h-lg";
    Type["xs"] = "type-2-xs";
    Type["xxs"] = "type-2-xxs";
    Type["xxxs"] = "type-2-xxxs";
    Type["eyebrowLarge"] = "type-eyebrow-large line-h-sm";
    Type["eyebrowSmall"] = "type-eyebrow-small line-h-sm";
})(exports.Type || (exports.Type = {}));
(function (Font) {
    Font["regular"] = "font-regular";
    Font["italic"] = "font-italic";
    Font["medium"] = "font-medium";
    Font["mediumItalic"] = "font-medium-italic";
    Font["bold"] = "font-bold";
    Font["boldItalic"] = "font-bold-italic";
    Font["black"] = "font-black";
    Font["blackItalic"] = "font-black-italic";
})(exports.Font || (exports.Font = {}));
});

var Focus = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.focus = exports.getFocusableChildren = void 0;


/** Get all the children of this element that are focusable. */
function getFocusableChildren(inElement) {
    return inElement ? Array.from(inElement.querySelectorAll(Constants.focusableSelector)) : [];
}
exports.getFocusableChildren = getFocusableChildren;
/** Transfer the focus to an element that isn't traditionally focusable. This is for accessibility purposes if you need to move the focus somewhere but don't exactly have a precise target for it. */
exports.focus = utils.makeSsrSafe(function (element, preventScroll) {
    if (preventScroll === void 0) { preventScroll = true; }
    if (!element) {
        return;
    }
    var selectable = element.matches(Constants.focusableSelector);
    var tabIndex;
    if (!selectable) {
        tabIndex = element.getAttribute("tabindex");
        element.tabIndex = 0;
    }
    var scrollX = window.scrollX, scrollY = window.scrollY;
    element.focus({
        preventScroll: preventScroll,
    });
    if (preventScroll && (window.scrollY !== scrollY || window.scrollX !== scrollX)) {
        window.scrollTo(scrollX, scrollY);
    }
    if (tabIndex) {
        element.setAttribute("tabindex", tabIndex);
    }
    else {
        element.removeAttribute("tabindex");
    }
});
});

var toStr$7 = Object.prototype.toString;

var isArguments = function isArguments(value) {
	var str = toStr$7.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr$7.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

var keysShim$1;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has$2 = Object.prototype.hasOwnProperty;
	var toStr$6 = Object.prototype.toString;
	var isArgs = isArguments; // eslint-disable-line global-require
	var isEnumerable$1 = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable$1.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable$1.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has$2.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim$1 = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr$6.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr$6.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has$2.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has$2.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has$2.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
var implementation$2 = keysShim$1;

var slice$1 = Array.prototype.slice;


var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : implementation$2;

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArguments(object)) {
					return originalKeys(slice$1.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

var objectKeys = keysShim;

/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams$1 = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

var origSymbol = typeof Symbol !== 'undefined' && Symbol;


var hasSymbols$3 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return shams$1();
};

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$5 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$5.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

var functionBind = Function.prototype.bind || implementation$1;

var src = functionBind.call(Function.call, Object.prototype.hasOwnProperty);

var undefined$1;

var $SyntaxError$2 = SyntaxError;
var $Function = Function;
var $TypeError$i = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
	try {
		$gOPD$2({}, '');
	} catch (e) {
		$gOPD$2 = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$i();
};
var ThrowTypeError = $gOPD$2
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD$2(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols$2 = hasSymbols$3();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols$2 ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols$2 ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols$2 ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols$2 ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols$2 ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError$2,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$i,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};



var $concat$1 = functionBind.call(Function.call, Array.prototype.concat);
var $spliceApply = functionBind.call(Function.apply, Array.prototype.splice);
var $replace$2 = functionBind.call(Function.call, String.prototype.replace);
var $strSlice$1 = functionBind.call(Function.call, String.prototype.slice);
var $exec$2 = functionBind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice$1(string, 0, 1);
	var last = $strSlice$1(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError$2('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError$2('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace$2(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace$2(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (src(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (src(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$i('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError$2('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$i('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$i('"allowMissing" argument must be a boolean');
	}

	if ($exec$2(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError$2('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat$1([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice$1(part, 0, 1);
		var last = $strSlice$1(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError$2('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (src(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$i('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD$2 && (i + 1) >= parts.length) {
				var desc = $gOPD$2(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = src(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

var $defineProperty$1 = getIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors$2 = function hasPropertyDescriptors() {
	if ($defineProperty$1) {
		try {
			$defineProperty$1({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors$2.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors$2()) {
		return null;
	}
	try {
		return $defineProperty$1([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

var hasPropertyDescriptors_1 = hasPropertyDescriptors$2;

var hasPropertyDescriptors$1 = hasPropertyDescriptors_1;

var hasSymbols$1 = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr$4 = Object.prototype.toString;
var concat$1 = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction$1 = function (fn) {
	return typeof fn === 'function' && toStr$4.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = hasPropertyDescriptors$1();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction$1(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = objectKeys(map);
	if (hasSymbols$1) {
		props = concat$1.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

var defineProperties_1 = defineProperties;

var hasUnscopables = typeof Symbol === 'function' && typeof Symbol.unscopables === 'symbol';

var map$1 = hasUnscopables && Array.prototype[Symbol.unscopables];

var $TypeError$h = TypeError;

var esShimUnscopables = function shimUnscopables(method) {
	if (typeof method !== 'string' || !method) {
		throw new $TypeError$h('method must be a non-empty string');
	}
	if (!src(Array.prototype, method)) {
		throw new $TypeError$h('method must be on Array.prototype');
	}
	if (hasUnscopables) {
		map$1[method] = true;
	}
};

var $abs = getIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

var abs$1 = function abs(x) {
	return $abs(x);
};

// var modulo = require('./modulo');
var $floor$1 = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

var floor$1 = function floor(x) {
	// return x - modulo(x, 1);
	return $floor$1(x);
};

// https://262.ecma-international.org/5.1/#sec-8

var Type$2 = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

var ES5Type = Type$2;

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

var Type$1 = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};

var _isNaN = Number.isNaN || function isNaN(a) {
	return a !== a;
};

var $isNaN$1 = Number.isNaN || function (a) { return a !== a; };

var _isFinite = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN$1(x) && x !== Infinity && x !== -Infinity; };

var abs = abs$1;

var floor = floor$1;

var Type = Type$1;

var $isNaN = _isNaN;

var $isFinite = _isFinite;

// https://tc39.es/ecma262/#sec-isintegralnumber

var IsIntegralNumber$1 = function IsIntegralNumber(argument) {
	if (Type(argument) !== 'Number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};

var IsIntegralNumber = IsIntegralNumber$1;

var $ArrayPrototype = getIntrinsic('%Array.prototype%');
var $RangeError = getIntrinsic('%RangeError%');
var $SyntaxError$1 = getIntrinsic('%SyntaxError%');
var $TypeError$g = getIntrinsic('%TypeError%');



var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = getIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/12.0/#sec-arraycreate

var ArrayCreate$1 = function ArrayCreate(length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$g('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 3, 5
	if (proto !== $ArrayPrototype) { // step 4
		if (!$setProto) {
			throw new $SyntaxError$1('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 6
		A.length = length;
	}
	/* step 6, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};

var util_inspect = require$$0$3.inspect;

var utilInspect = util_inspect;

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match$1 = String.prototype.match;
var $slice = String.prototype.slice;
var $replace$1 = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace$1.call(intStr, sepRegex, '$&_') + '.' + $replace$1.call($replace$1.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace$1.call(str, sepRegex, '$&_');
}


var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$1(inspectCustom) ? inspectCustom : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$1(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$1(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$1(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$1(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has$1(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$2(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$1(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol$1(obj)) {
        var symString = hasShammedSymbols ? $replace$1.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray$2(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr$3(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace$1.call(String(s), /"/g, '&quot;');
}

function isArray$2(obj) { return toStr$3(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr$3(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr$3(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr$3(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr$3(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr$3(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr$3(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol$1(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$1(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr$3(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match$1.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace$1.call($replace$1.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$2(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$1(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$1(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

var IsPropertyKey$1 = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

var inspect = objectInspect;

var IsPropertyKey = IsPropertyKey$1;

var $TypeError$f = getIntrinsic('%TypeError%');






// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

var Get$1 = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError$f('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError$f('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};

var callBind = createCommonjsModule(function (module) {




var $apply = getIntrinsic('%Function.prototype.apply%');
var $call = getIntrinsic('%Function.prototype.call%');
var $reflectApply = getIntrinsic('%Reflect.apply%', true) || functionBind.call($call, $apply);

var $gOPD = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = getIntrinsic('%Object.defineProperty%', true);
var $max = getIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(functionBind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(functionBind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
});

var $indexOf = callBind(getIntrinsic('String.prototype.indexOf'));

var callBound = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = getIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

var $Array = getIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr$2 = !$Array.isArray && callBound('Object.prototype.toString');

var IsArray$2 = $Array.isArray || function IsArray(argument) {
	return toStr$2(argument) === '[object Array]';
};

var require$$0$2 = IsArray$2;

// https://ecma-international.org/ecma-262/6.0/#sec-isarray
var IsArray$1 = require$$0$2;

// TODO: remove, semver-major

var GetIntrinsic$1 = getIntrinsic;

var $TypeError$e = getIntrinsic('%TypeError%');

var isPropertyDescriptor$1 = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (src(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError$e('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};

var $defineProperty = hasPropertyDescriptors$1() && getIntrinsic('%Object.defineProperty%', true);

var hasArrayLengthDefineBug = hasPropertyDescriptors$1.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray$1 = hasArrayLengthDefineBug && require$$0$2;



var $isEnumerable$1 = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
var DefineOwnProperty$1 = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable$1(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray$1(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};

// https://262.ecma-international.org/13.0/#sec-match-records

var isMatchRecord$1 = function isMatchRecord(record) {
	return (
		src(record, '[[StartIndex]]')
        && src(record, '[[EndIndex]]')
        && record['[[StartIndex]]'] >= 0
        && record['[[EndIndex]]'] >= record['[[StartIndex]]']
        && String(parseInt(record['[[StartIndex]]'], 10)) === String(record['[[StartIndex]]'])
        && String(parseInt(record['[[EndIndex]]'], 10)) === String(record['[[EndIndex]]'])
	);
};

var isMatchRecord = isMatchRecord$1;

var $TypeError$d = getIntrinsic('%TypeError%');
var $SyntaxError = getIntrinsic('%SyntaxError%');





var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Desc) {
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (src(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = src(Desc, '[[Value]]');
		var IsAccessor = src(Desc, '[[Get]]') || src(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError$d('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},
	// https://262.ecma-international.org/13.0/#sec-match-records
	'Match Record': isMatchRecord
};

var assertRecord$1 = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (Type(value) !== 'Object' || !predicate(value)) {
		throw new $TypeError$d(argumentName + ' must be a ' + recordType);
	}
};

var fromPropertyDescriptor$1 = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};

var assertRecord = assertRecord$1;

var fromPropertyDescriptor = fromPropertyDescriptor$1;

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

var FromPropertyDescriptor$1 = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined') {
		assertRecord(Type, 'Property Descriptor', 'Desc', Desc);
	}

	return fromPropertyDescriptor(Desc);
};

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

var IsAccessorDescriptor$1 = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Get]]') && !src(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

var IsDataDescriptor$1 = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!src(Desc, '[[Value]]') && !src(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};

// http://262.ecma-international.org/5.1/#sec-9.12

var SameValue$1 = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};

// http://262.ecma-international.org/5.1/#sec-9.2

var ToBoolean$1 = function ToBoolean(value) { return !!value; };

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr$1 = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag$2 = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

var isCallable = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag$2) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr$1.call(value);
		return strClass === fnClass || strClass === genClass;
	};

// http://262.ecma-international.org/5.1/#sec-9.11

var IsCallable$1 = isCallable;

var ToBoolean = ToBoolean$1;

var IsCallable = IsCallable$1;

var $TypeError$c = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/5.1/#sec-8.10.5

var ToPropertyDescriptor$1 = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError$c('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (src(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (src(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (src(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (src(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (src(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError$c('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (src(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError$c('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((src(desc, '[[Get]]') || src(desc, '[[Set]]')) && (src(desc, '[[Value]]') || src(desc, '[[Writable]]'))) {
		throw new $TypeError$c('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};

var isPropertyDescriptor = isPropertyDescriptor$1;

var DefineOwnProperty = DefineOwnProperty$1;

var FromPropertyDescriptor = FromPropertyDescriptor$1;

var IsAccessorDescriptor = IsAccessorDescriptor$1;

var IsDataDescriptor = IsDataDescriptor$1;

var SameValue = SameValue$1;

var ToPropertyDescriptor = ToPropertyDescriptor$1;

var $TypeError$b = getIntrinsic('%TypeError%');












// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

var DefinePropertyOrThrow = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$b('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError$b('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError$b('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};

var GetIntrinsic = GetIntrinsic$1;

var require$$0$1 = DefinePropertyOrThrow;

var IsConstructor$1 = createCommonjsModule(function (module) {



var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = require$$0$1;
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}
});

var ArrayCreate = ArrayCreate$1;

var Get = Get$1;

var IsArray = IsArray$1;

var IsConstructor = IsConstructor$1;

var $species = getIntrinsic('%Symbol.species%', true);
var $TypeError$a = getIntrinsic('%TypeError%');








// https://ecma-international.org/ecma-262/12.0/#sec-arrayspeciescreate

var ArraySpeciesCreate$1 = function ArraySpeciesCreate(originalArray, length) {
	if (!IsIntegralNumber(length) || length < 0) {
		throw new $TypeError$a('Assertion failed: length must be an integer >= 0');
	}

	var isArray = IsArray(originalArray);
	if (!isArray) {
		return ArrayCreate(length);
	}

	var C = Get(originalArray, 'constructor');
	// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
	// if (IsConstructor(C)) {
	// 	if C is another realm's Array, C = undefined
	// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
	// }
	if ($species && Type(C) === 'Object') {
		C = Get(C, $species);
		if (C === null) {
			C = void 0;
		}
	}

	if (typeof C === 'undefined') {
		return ArrayCreate(length);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError$a('C must be a constructor');
	}
	return new C(length); // Construct(C, length);
};

var $Math = getIntrinsic('%Math%');
var $Number$1 = getIntrinsic('%Number%');

var maxSafeInteger = $Number$1.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;

var $TypeError$9 = getIntrinsic('%TypeError%');



var $apply = getIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

var Call$1 = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError$9('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};

var $gOPD$1 = getIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD$1) {
	try {
		$gOPD$1([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD$1 = null;
	}
}

var getOwnPropertyDescriptor = $gOPD$1;

var shams = function hasToStringTagShams() {
	return shams$1() && !!Symbol.toStringTag;
};

var hasToStringTag$1 = shams();
var has;
var $exec$1;
var isRegexMarker;
var badStringifier;

if (hasToStringTag$1) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec$1 = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

var isRegex = hasToStringTag$1
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec$1(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};

var $match = getIntrinsic('%Symbol.match%', true);





// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

var IsRegExp$1 = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return isRegex(argument);
};

var $gOPD = getOwnPropertyDescriptor;

var IsRegExp = IsRegExp$1;

var $TypeError$8 = getIntrinsic('%TypeError%');



var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');









// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

var OrdinaryGetOwnProperty$1 = function OrdinaryGetOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$8('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$8('Assertion failed: P must be a Property Key');
	}
	if (!src(O, P)) {
		return void 0;
	}
	if (!$gOPD) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor($gOPD(O, P));
};

var isPrimitive$2 = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var isPrimitive$1 = isPrimitive$2;

var $preventExtensions = getIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = getIntrinsic('%Object.isExtensible%', true);



// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

var IsExtensible$1 = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive$1(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive$1(obj);
	};

var OrdinaryGetOwnProperty = OrdinaryGetOwnProperty$1;

var IsExtensible = IsExtensible$1;

var $TypeError$7 = getIntrinsic('%TypeError%');











// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

var CreateDataProperty$1 = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$7('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$7('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var nonConfigurable = oldDesc && !oldDesc['[[Configurable]]'];
	if (nonConfigurable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};

var CreateDataProperty = CreateDataProperty$1;

var $TypeError$6 = getIntrinsic('%TypeError%');





// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

var CreateDataPropertyOrThrow$1 = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$6('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$6('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError$6('unable to create data property');
	}
	return success;
};

var $TypeError$5 = getIntrinsic('%TypeError%');




// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

var HasProperty$1 = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError$5('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError$5('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

var $exec = callBound('RegExp.prototype.exec');

var regexTester$1 = function regexTester(regex) {
	return function test(s) { return $exec(regex, s) !== null; };
};

var isPrimitive = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = shams();

var isDateObject = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

var isSymbol = createCommonjsModule(function (module) {

var toStr = Object.prototype.toString;
var hasSymbols = hasSymbols$3();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false ;
	};
}
});

var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';






var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
var es2015 = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDateObject(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

var ToPrimitive$1 = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return es2015(input, arguments[1]);
	}
	return es2015(input);
};

var regexTester = regexTester$1;

var ToPrimitive = ToPrimitive$1;

var $TypeError$4 = getIntrinsic('%TypeError%');
var $Number = getIntrinsic('%Number%');
var $RegExp = getIntrinsic('%RegExp%');
var $parseInteger = getIntrinsic('%parseInt%');





var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};



// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

var ToNumber$1 = function ToNumber(argument) {
	var value = isPrimitive$1(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError$4('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError$4('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};

var sign = function sign(number) {
	return number >= 0 ? 1 : -1;
};

var ToNumber = ToNumber$1;

var $sign = sign;

// https://262.ecma-international.org/12.0/#sec-tointegerorinfinity

var ToIntegerOrInfinity$1 = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0) { return 0; }
	if (!$isFinite(number)) { return number; }
	return $sign(number) * floor(abs(number));
};

var MAX_SAFE_INTEGER = maxSafeInteger;

var ToIntegerOrInfinity = ToIntegerOrInfinity$1;

var ToLength$1 = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};

var ToLength = ToLength$1;

var $TypeError$3 = getIntrinsic('%TypeError%');





// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

var LengthOfArrayLike$1 = function LengthOfArrayLike(obj) {
	if (Type(obj) !== 'Object') {
		throw new $TypeError$3('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

var $String = getIntrinsic('%String%');
var $TypeError$2 = getIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

var ToString$1 = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError$2('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

var Call = Call$1;

var CreateDataPropertyOrThrow = CreateDataPropertyOrThrow$1;

var HasProperty = HasProperty$1;

var LengthOfArrayLike = LengthOfArrayLike$1;

var ToString = ToString$1;

var $TypeError$1 = getIntrinsic('%TypeError%');











// https://262.ecma-international.org/11.0/#sec-flattenintoarray

// eslint-disable-next-line max-params
var FlattenIntoArray$1 = function FlattenIntoArray(target, source, sourceLen, start, depth) {
	var mapperFunction;
	if (arguments.length > 5) {
		mapperFunction = arguments[5];
	}

	var targetIndex = start;
	var sourceIndex = 0;
	while (sourceIndex < sourceLen) {
		var P = ToString(sourceIndex);
		var exists = HasProperty(source, P);
		if (exists === true) {
			var element = Get(source, P);
			if (typeof mapperFunction !== 'undefined') {
				if (arguments.length <= 6) {
					throw new $TypeError$1('Assertion failed: thisArg is required when mapperFunction is provided');
				}
				element = Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
			}
			var shouldFlatten = false;
			if (depth > 0) {
				shouldFlatten = IsArray(element);
			}
			if (shouldFlatten) {
				var elementLen = LengthOfArrayLike(element);
				targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
			} else {
				if (targetIndex >= MAX_SAFE_INTEGER) {
					throw new $TypeError$1('index too large');
				}
				CreateDataPropertyOrThrow(target, ToString(targetIndex), element);
				targetIndex += 1;
			}
		}
		sourceIndex += 1;
	}

	return targetIndex;
};

var $TypeError = getIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

var CheckObjectCoercible = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

var require$$0 = CheckObjectCoercible;

var RequireObjectCoercible$1 = require$$0;

var RequireObjectCoercible = RequireObjectCoercible$1;

var $Object = getIntrinsic('%Object%');



// https://ecma-international.org/ecma-262/6.0/#sec-toobject

var ToObject$1 = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};

var ArraySpeciesCreate = ArraySpeciesCreate$1;

var FlattenIntoArray = FlattenIntoArray$1;

var ToObject = ToObject$1;

var implementation = function flat() {
	var O = ToObject(this);
	var sourceLen = ToLength(Get(O, 'length'));

	var depthNum = 1;
	if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
		depthNum = ToIntegerOrInfinity(arguments[0]);
	}

	var A = ArraySpeciesCreate(O, 0);
	FlattenIntoArray(A, O, sourceLen, 0, depthNum);
	return A;
};

var polyfill = function getPolyfill() {
	return Array.prototype.flat || implementation;
};

var shim = function shimFlat() {
	var polyfill$1 = polyfill();

	defineProperties_1(
		Array.prototype,
		{ flat: polyfill$1 },
		{ flat: function () { return Array.prototype.flat !== polyfill$1; } }
	);

	esShimUnscopables('flat');

	return polyfill$1;
};

shim();

var FlatFilter = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatfiltermap = exports.filtermap = exports.flatfilter = exports.flatmap = exports.flat = exports.map = exports.filter = exports.assertType = void 0;
/** Asserts the type of obj at compile-time */
function assertType(_obj) {
    return;
}
exports.assertType = assertType;
function wrap(array) {
    return Array.isArray(array) ? array : [array];
}
function filter(array) {
    return wrap(array).filter(Boolean);
}
exports.filter = filter;
function map(array, mapper) {
    return wrap(array).map(mapper);
}
exports.map = map;
function flat(array) {
    return wrap(array).flat(Infinity);
}
exports.flat = flat;
function flatmap(array, mapper) {
    return map(flat(array), mapper);
}
exports.flatmap = flatmap;
function flatfilter(array) {
    return filter(flat(array));
}
exports.flatfilter = flatfilter;
function filtermap(array, mapper) {
    return filter(map(array, mapper));
}
exports.filtermap = filtermap;
function flatfiltermap(array, mapper) {
    return filtermap(flat(array), mapper);
}
exports.flatfiltermap = flatfiltermap;
});

var Join = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.join = void 0;

/** Create a single CSS class from a set of classes or conditional classes. */
function join() {
    var potentials = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        potentials[_i] = arguments[_i];
    }
    // Edge is stubborn and adds commas anyways. Let's replace them with spaces.
    return FlatFilter.flatfilter(potentials)
        .join(" ")
        .replace(/,/g, " ");
}
exports.join = join;
});

var Refs = createCommonjsModule(function (module, exports) {
var __values = (commonjsGlobal && commonjsGlobal.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.refs = void 0;

/** Combine a set of refs into a single ref callback. */
function refs() {
    var refsToCombine = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refsToCombine[_i] = arguments[_i];
    }
    return function (instance) {
        var e_1, _a;
        try {
            for (var _b = __values(FlatFilter.flatfilter(refsToCombine)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var ref = _c.value;
                if (typeof ref === "function") {
                    ref(instance);
                }
                else if (ref && typeof ref === "object" && "current" in ref) {
                    ref.current = instance;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
}
exports.refs = refs;
});

var ConcatUrls = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUrls = void 0;

function concatUrls() {
    var urls = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        urls[_i] = arguments[_i];
    }
    var filtered = FlatFilter.flatfilter(urls);
    return filtered.length > 0 ? "/" + filtered.join("/").replace(/^\/+|\/+$|\/+(\/)/g, "$1") : "";
}
exports.concatUrls = concatUrls;
});

var Reporting = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingHelper = void 0;



var service;
exports.ReportingHelper = {
    get initialized() {
        return Boolean(service);
    },
    initialize: function (ReportingServiceClass) {
        service = ReportingServiceClass.getInstance();
    },
    pageLoad: function (_a) {
        var suffix = _a.url, prefix = _a.prefix, flowCode = _a.flowCode, lineOfBusiness = _a.lineOfBusiness, maybeDisplayedMessage = _a.displayedMessage, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls.concatUrls(prefix, suffix);
        var displayedMessage = FlatFilter.flatfilter(maybeDisplayedMessage).join("|");
        // 	console.log(`ReportingHelper: pageLoad ->
        // url : ${url}
        // flowCode : ${flowCode}
        // lineOfBusiness: ${lineOfBusiness}${
        // 		displayedMessage
        // 			? `
        // displayedMessage: ${displayedMessage}`
        // 			: ``
        // 	}`)
        service.firePageLoadEvent(__assign({ url: url, "page.pageInfo.flowCode": flowCode, "page.pageInfo.lineOfBusiness": lineOfBusiness, "page.attributes.displayedMessage": displayedMessage }, additionalParameters));
    },
    linkClick: function (_a) {
        var name = _a.name, _b = _a.position, position = _b === void 0 ? "Body" : _b, suffix = _a.url, prefix = _a.prefix, pageUrl = _a.pageUrl, pagePrefix = _a.pagePrefix, additionalParameters = _a.additionalParameters;
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var url = ConcatUrls.concatUrls(prefix, suffix);
        // 	console.log(
        // 		`ReportingHelper: linkClick ->
        // name: ${name}
        // position: ${position}${
        // 			url
        // 				? `
        // url: ${url}`
        // 				: ""
        // 		}`
        // 	)
        if (pageUrl) {
            this.pageLoad({ url: pageUrl, prefix: pagePrefix });
        }
        service.fireLinkClickEvent(__assign({ linkName: name, linkPosition: position, linkDestinationUrl: url }, additionalParameters));
    },
    systemEvent: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireSystemEvent(name, data);
    },
    formSubmit: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireFormSubmitEvent(name, data);
    },
    formResponse: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var _a = logEventPayload(payload), name = _a.name, data = _a.data;
        service.fireFormResponseEvent(name, data);
    },
    impression: function (payload) {
        if (!service) {
            throw new Error("Please call `ReportingHelper.initialize()` first.");
        }
        var data = Simplify.simplify(payload).data;
        // console.log(
        // 	`ReportingHelper: impression ->
        //         data: ${data ? JSON.stringify(data) : ""}
        //     `
        // )
        service.fireImpression(data);
    },
};
/** Function for logging, simplifying, and returning payloads for systemEvent or formSubmit due to their similarity */
function logEventPayload(payload, _eventType) {
    var _a = Simplify.simplify(payload), name = _a.name, data = _a.data;
    // 	console.log(
    // 		`ReportingHelper: ${_eventType} ->
    // eventName: ${name}${
    // 			data
    // 				? `
    // additionalData: ${JSON.stringify(data)}`
    // 				: ``
    // 		}`
    // 	)
    return { name: name, data: data };
}
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isFunction(x) {
    return typeof x === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var _enable_super_gross_mode_that_will_cause_bad_things = false;
var config = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling(value) {
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn('DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n' + error.stack);
        }
        _enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling() {
        return _enable_super_gross_mode_that_will_cause_bad_things;
    },
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function hostReportError(err) {
    setTimeout(function () { throw err; }, 0);
}

/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */
var empty$1 = {
    closed: true,
    next: function (value) { },
    error: function (err) {
        if (config.useDeprecatedSynchronousErrorHandling) {
            throw err;
        }
        else {
            hostReportError(err);
        }
    },
    complete: function () { }
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArray = /*@__PURE__*/ (function () { return Array.isArray || (function (x) { return x && typeof x.length === 'number'; }); })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isObject(x) {
    return x !== null && typeof x === 'object';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var UnsubscriptionErrorImpl = /*@__PURE__*/ (function () {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ?
            errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
})();
var UnsubscriptionError = UnsubscriptionErrorImpl;

/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */
var Subscription = /*@__PURE__*/ (function () {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function () {
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) {
            _parentOrParents.remove(this);
        }
        else if (_parentOrParents !== null) {
            for (var index = 0; index < _parentOrParents.length; ++index) {
                var parent_1 = _parentOrParents[index];
                parent_1.remove(this);
            }
        }
        if (isFunction(_unsubscribe)) {
            if (_ctorUnsubscribe) {
                this._unsubscribe = undefined;
            }
            try {
                _unsubscribe.call(this);
            }
            catch (e) {
                errors = e instanceof UnsubscriptionError ? flattenUnsubscriptionErrors(e.errors) : [e];
            }
        }
        if (isArray(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject(sub)) {
                    try {
                        sub.unsubscribe();
                    }
                    catch (e) {
                        errors = errors || [];
                        if (e instanceof UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(e.errors));
                        }
                        else {
                            errors.push(e);
                        }
                    }
                }
            }
        }
        if (errors) {
            throw new UnsubscriptionError(errors);
        }
    };
    Subscription.prototype.add = function (teardown) {
        var subscription = teardown;
        if (!teardown) {
            return Subscription.EMPTY;
        }
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default: {
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
            }
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) {
            subscription._parentOrParents = this;
        }
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) {
                return subscription;
            }
            subscription._parentOrParents = [_parentOrParents, this];
        }
        else if (_parentOrParents.indexOf(this) === -1) {
            _parentOrParents.push(this);
        }
        else {
            return subscription;
        }
        var subscriptions = this._subscriptions;
        if (subscriptions === null) {
            this._subscriptions = [subscription];
        }
        else {
            subscriptions.push(subscription);
        }
        return subscription;
    };
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError) ? err.errors : err); }, []);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var rxSubscriber = /*@__PURE__*/ (function () {
    return typeof Symbol === 'function'
        ? /*@__PURE__*/ Symbol('rxSubscriber')
        : '@@rxSubscriber_' + /*@__PURE__*/ Math.random();
})();

/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */
var Subscriber = /*@__PURE__*/ (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch (arguments.length) {
            case 0:
                _this.destination = empty$1;
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = empty$1;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    }
                    else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new SafeSubscriber(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new SafeSubscriber(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[rxSubscriber] = function () { return this; };
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}(Subscription));
var SafeSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if (isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== empty$1) {
                context = Object.create(observerOrNext);
                if (isFunction(context.unsubscribe)) {
                    _this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = config.useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) {
                    throw err;
                }
                hostReportError(err);
            }
            else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                }
                else {
                    hostReportError(err);
                }
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function () { return _this._complete.call(_this._context); };
                if (!config.useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            if (config.useDeprecatedSynchronousErrorHandling) {
                throw err;
            }
            else {
                hostReportError(err);
            }
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        if (!config.useDeprecatedSynchronousErrorHandling) {
            throw new Error('bad call');
        }
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            }
            else {
                hostReportError(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */
function canReportError(observer) {
    while (observer) {
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) {
            return false;
        }
        else if (destination && destination instanceof Subscriber) {
            observer = destination;
        }
        else {
            observer = null;
        }
    }
    return true;
}

/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber]) {
            return nextOrObserver[rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber(empty$1);
    }
    return new Subscriber(nextOrObserver, error, complete);
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var observable = /*@__PURE__*/ (function () { return typeof Symbol === 'function' && Symbol.observable || '@@observable'; })();

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function identity(x) {
    return x;
}

/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */
function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return identity;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}

/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */
var Observable = /*@__PURE__*/ (function () {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber(observerOrNext, error, complete);
        if (operator) {
            sink.add(operator.call(sink, this.source));
        }
        else {
            sink.add(this.source || (config.useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable) ?
                this._subscribe(sink) :
                this._trySubscribe(sink));
        }
        if (config.useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) {
                    throw sink.syncErrorValue;
                }
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            if (config.useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if (canReportError(sink)) {
                sink.error(err);
            }
            else {
                console.warn(err);
            }
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    if (subscription) {
                        subscription.unsubscribe();
                    }
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        if (operations.length === 0) {
            return this;
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
function getPromiseCtor(promiseCtor) {
    if (!promiseCtor) {
        promiseCtor = config.Promise || Promise;
    }
    if (!promiseCtor) {
        throw new Error('no Promise impl found');
    }
    return promiseCtor;
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ObjectUnsubscribedErrorImpl = /*@__PURE__*/ (function () {
    function ObjectUnsubscribedErrorImpl() {
        Error.call(this);
        this.message = 'object unsubscribed';
        this.name = 'ObjectUnsubscribedError';
        return this;
    }
    ObjectUnsubscribedErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ObjectUnsubscribedErrorImpl;
})();
var ObjectUnsubscribedError = ObjectUnsubscribedErrorImpl;

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var SubjectSubscription = /*@__PURE__*/ (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        var _this = _super.call(this) || this;
        _this.subject = subject;
        _this.subscriber = subscriber;
        _this.closed = false;
        return _this;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Observable,_Subscriber,_Subscription,_util_ObjectUnsubscribedError,_SubjectSubscription,_internal_symbol_rxSubscriber PURE_IMPORTS_END */
var SubjectSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.destination = destination;
        return _this;
    }
    return SubjectSubscriber;
}(Subscriber));
var Subject = /*@__PURE__*/ (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.observers = [];
        _this.closed = false;
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype[rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable));
var AnonymousSubject = /*@__PURE__*/ (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function refCount() {
    return function refCountOperatorFunction(source) {
        return source.lift(new RefCountOperator(source));
    };
}
var RefCountOperator = /*@__PURE__*/ (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START tslib,_Subject,_Observable,_Subscriber,_Subscription,_operators_refCount PURE_IMPORTS_END */
var ConnectableObservable = /*@__PURE__*/ (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._refCount = 0;
        _this._isComplete = false;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            this._isComplete = false;
            connection = this._connection = new Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription.EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return refCount()(this);
    };
    return ConnectableObservable;
}(Observable));
var ConnectableSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        var _this = _super.call(this, destination) || this;
        _this.connectable = connectable;
        return _this;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this.connectable._isComplete = true;
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(SubjectSubscriber));

/** PURE_IMPORTS_START tslib,_Subscriber,_Subscription,_Observable,_Subject PURE_IMPORTS_END */
var GroupedObservable = /*@__PURE__*/ (function (_super) {
    __extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        var _this = _super.call(this) || this;
        _this.key = key;
        _this.groupSubject = groupSubject;
        _this.refCountSubscription = refCountSubscription;
        return _this;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable));
var InnerRefCountSubscription = /*@__PURE__*/ (function (_super) {
    __extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        parent.count++;
        return _this;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Subject,_util_ObjectUnsubscribedError PURE_IMPORTS_END */
var BehaviorSubject = /*@__PURE__*/ (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject));

/** PURE_IMPORTS_START tslib,_Subscription PURE_IMPORTS_END */
var Action = /*@__PURE__*/ (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        return this;
    };
    return Action;
}(Subscription));

/** PURE_IMPORTS_START tslib,_Action PURE_IMPORTS_END */
var AsyncAction = /*@__PURE__*/ (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        return setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && this.delay === delay && this.pending === false) {
            return id;
        }
        clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
        this.delay = null;
    };
    return AsyncAction;
}(Action));

/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
var QueueAction = /*@__PURE__*/ (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction));

var Scheduler = /*@__PURE__*/ (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = function () { return Date.now(); };
    return Scheduler;
}());

/** PURE_IMPORTS_START tslib,_Scheduler PURE_IMPORTS_END */
var AsyncScheduler = /*@__PURE__*/ (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
            now = Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, function () {
            if (AsyncScheduler.delegate && AsyncScheduler.delegate !== _this) {
                return AsyncScheduler.delegate.now();
            }
            else {
                return now();
            }
        }) || this;
        _this.actions = [];
        _this.active = false;
        _this.scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
            delay = 0;
        }
        if (AsyncScheduler.delegate && AsyncScheduler.delegate !== this) {
            return AsyncScheduler.delegate.schedule(work, delay, state);
        }
        else {
            return _super.prototype.schedule.call(this, work, delay, state);
        }
    };
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift());
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var QueueScheduler = /*@__PURE__*/ (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _QueueAction,_QueueScheduler PURE_IMPORTS_END */
var queueScheduler = /*@__PURE__*/ new QueueScheduler(QueueAction);
var queue = queueScheduler;

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
var EMPTY = /*@__PURE__*/ new Observable(function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new Observable(function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var subscribeToArray = function (array) {
    return function (subscriber) {
        for (var i = 0, len = array.length; i < len && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    };
};

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function scheduleArray(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        var i = 0;
        sub.add(scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
                sub.add(this.schedule());
            }
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function fromArray(input, scheduler) {
    if (!scheduler) {
        return new Observable(subscribeToArray(input));
    }
    else {
        return scheduleArray(input, scheduler);
    }
}

/** PURE_IMPORTS_START _util_isScheduler,_fromArray,_scheduled_scheduleArray PURE_IMPORTS_END */
function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = args[args.length - 1];
    if (isScheduler(scheduler)) {
        args.pop();
        return scheduleArray(args, scheduler);
    }
    else {
        return fromArray(args);
    }
}

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function throwError(error, scheduler) {
    if (!scheduler) {
        return new Observable(function (subscriber) { return subscriber.error(error); });
    }
    else {
        return new Observable(function (subscriber) { return scheduler.schedule(dispatch$7, 0, { error: error, subscriber: subscriber }); });
    }
}
function dispatch$7(_a) {
    var error = _a.error, subscriber = _a.subscriber;
    subscriber.error(error);
}

/** PURE_IMPORTS_START _observable_empty,_observable_of,_observable_throwError PURE_IMPORTS_END */
var NotificationKind;
/*@__PURE__*/ (function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = /*@__PURE__*/ (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return of(this.value);
            case 'E':
                return throwError(this.error);
            case 'C':
                return empty();
        }
        throw new Error('unexpected notification kind value');
    };
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return Notification.undefinedValueNotification;
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());

/** PURE_IMPORTS_START tslib,_Subscriber,_Notification PURE_IMPORTS_END */
var ObserveOnSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        var _this = _super.call(this, destination) || this;
        _this.scheduler = scheduler;
        _this.delay = delay;
        return _this;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        var destination = this.destination;
        destination.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification.createError(err));
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification.createComplete());
        this.unsubscribe();
    };
    return ObserveOnSubscriber;
}(Subscriber));
var ObserveOnMessage = /*@__PURE__*/ (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());

/** PURE_IMPORTS_START tslib,_Subject,_scheduler_queue,_Subscription,_operators_observeOn,_util_ObjectUnsubscribedError,_SubjectSubscription PURE_IMPORTS_END */
var ReplaySubject = /*@__PURE__*/ (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) {
            bufferSize = Number.POSITIVE_INFINITY;
        }
        if (windowTime === void 0) {
            windowTime = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this) || this;
        _this.scheduler = scheduler;
        _this._events = [];
        _this._infiniteTimeWindow = false;
        _this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        _this._windowTime = windowTime < 1 ? 1 : windowTime;
        if (windowTime === Number.POSITIVE_INFINITY) {
            _this._infiniteTimeWindow = true;
            _this.next = _this.nextInfiniteTimeWindow;
        }
        else {
            _this.next = _this.nextTimeWindow;
        }
        return _this;
    }
    ReplaySubject.prototype.nextInfiniteTimeWindow = function (value) {
        if (!this.isStopped) {
            var _events = this._events;
            _events.push(value);
            if (_events.length > this._bufferSize) {
                _events.shift();
            }
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype.nextTimeWindow = function (value) {
        if (!this.isStopped) {
            this._events.push(new ReplayEvent(this._getNow(), value));
            this._trimBufferThenGetEvents();
        }
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _infiniteTimeWindow = this._infiniteTimeWindow;
        var _events = _infiniteTimeWindow ? this._events : this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var len = _events.length;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError();
        }
        else if (this.isStopped || this.hasError) {
            subscription = Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new ObserveOnSubscriber(subscriber, scheduler));
        }
        if (_infiniteTimeWindow) {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i]);
            }
        }
        else {
            for (var i = 0; i < len && !subscriber.closed; i++) {
                subscriber.next(_events[i].value);
            }
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject));
var ReplayEvent = /*@__PURE__*/ (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());

/** PURE_IMPORTS_START tslib,_Subject,_Subscription PURE_IMPORTS_END */
var AsyncSubject = /*@__PURE__*/ (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        _this.hasNext = false;
        _this.hasCompleted = false;
        return _this;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var nextHandle = 1;
var RESOLVED = /*@__PURE__*/ (function () { return /*@__PURE__*/ Promise.resolve(); })();
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        RESOLVED.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};

/** PURE_IMPORTS_START tslib,_util_Immediate,_AsyncAction PURE_IMPORTS_END */
var AsapAction = /*@__PURE__*/ (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(AsyncAction));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var AsapScheduler = /*@__PURE__*/ (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _AsapAction,_AsapScheduler PURE_IMPORTS_END */
var asapScheduler = /*@__PURE__*/ new AsapScheduler(AsapAction);
var asap = asapScheduler;

/** PURE_IMPORTS_START _AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var asyncScheduler = /*@__PURE__*/ new AsyncScheduler(AsyncAction);
var async = asyncScheduler;

/** PURE_IMPORTS_START tslib,_AsyncAction PURE_IMPORTS_END */
var AnimationFrameAction = /*@__PURE__*/ (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler.scheduled || (scheduler.scheduled = requestAnimationFrame(function () { return scheduler.flush(null); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction));

/** PURE_IMPORTS_START tslib,_AsyncScheduler PURE_IMPORTS_END */
var AnimationFrameScheduler = /*@__PURE__*/ (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler));

/** PURE_IMPORTS_START _AnimationFrameAction,_AnimationFrameScheduler PURE_IMPORTS_END */
var animationFrameScheduler = /*@__PURE__*/ new AnimationFrameScheduler(AnimationFrameAction);
var animationFrame = animationFrameScheduler;

/** PURE_IMPORTS_START tslib,_AsyncAction,_AsyncScheduler PURE_IMPORTS_END */
var VirtualTimeScheduler = /*@__PURE__*/ (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        if (SchedulerAction === void 0) {
            SchedulerAction = VirtualAction;
        }
        if (maxFrames === void 0) {
            maxFrames = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, SchedulerAction, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler));
var VirtualAction = /*@__PURE__*/ (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) {
            index = scheduler.index += 1;
        }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) {
            delay = 0;
        }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function noop() { }

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function isObservable(obj) {
    return !!obj && (obj instanceof Observable || (typeof obj.lift === 'function' && typeof obj.subscribe === 'function'));
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ (function () {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = 'argument out of range';
        this.name = 'ArgumentOutOfRangeError';
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
})();
var ArgumentOutOfRangeError = ArgumentOutOfRangeErrorImpl;

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var EmptyErrorImpl = /*@__PURE__*/ (function () {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = 'no elements in sequence';
        this.name = 'EmptyError';
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
})();
var EmptyError = EmptyErrorImpl;

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var TimeoutErrorImpl = /*@__PURE__*/ (function () {
    function TimeoutErrorImpl() {
        Error.call(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        return this;
    }
    TimeoutErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return TimeoutErrorImpl;
})();
var TimeoutError = TimeoutErrorImpl;

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function map(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return source.lift(new MapOperator(project, thisArg));
    };
}
var MapOperator = /*@__PURE__*/ (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
var MapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isArray,_util_isScheduler PURE_IMPORTS_END */
function bindCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = this;
        var subject;
        var params = {
            context: context,
            subject: subject,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
        };
        return new Observable(function (subscriber) {
            if (!scheduler) {
                if (!subject) {
                    subject = new AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                var state = {
                    args: args, subscriber: subscriber, params: params,
                };
                return scheduler.schedule(dispatch$6, 0, state);
            }
        });
    };
}
function dispatch$6(state) {
    var _this = this;
    var args = state.args, subscriber = state.subscriber, params = state.params;
    var callbackFunc = params.callbackFunc, context = params.context, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
            _this.add(scheduler.schedule(dispatchNext$1, 0, { value: value, subject: subject }));
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            subject.error(err);
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext$1(state) {
    var value = state.value, subject = state.subject;
    subject.next(value);
    subject.complete();
}

/** PURE_IMPORTS_START _Observable,_AsyncSubject,_operators_map,_util_canReportError,_util_isScheduler,_util_isArray PURE_IMPORTS_END */
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (isScheduler(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindNodeCallback(callbackFunc, scheduler).apply(void 0, args).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
            };
        }
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var params = {
            subject: undefined,
            args: args,
            callbackFunc: callbackFunc,
            scheduler: scheduler,
            context: this,
        };
        return new Observable(function (subscriber) {
            var context = params.context;
            var subject = params.subject;
            if (!scheduler) {
                if (!subject) {
                    subject = params.subject = new AsyncSubject();
                    var handler = function () {
                        var innerArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            innerArgs[_i] = arguments[_i];
                        }
                        var err = innerArgs.shift();
                        if (err) {
                            subject.error(err);
                            return;
                        }
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    };
                    try {
                        callbackFunc.apply(context, args.concat([handler]));
                    }
                    catch (err) {
                        if (canReportError(subject)) {
                            subject.error(err);
                        }
                        else {
                            console.warn(err);
                        }
                    }
                }
                return subject.subscribe(subscriber);
            }
            else {
                return scheduler.schedule(dispatch$5, 0, { params: params, subscriber: subscriber, context: context });
            }
        });
    };
}
function dispatch$5(state) {
    var _this = this;
    var params = state.params, subscriber = state.subscriber, context = state.context;
    var callbackFunc = params.callbackFunc, args = params.args, scheduler = params.scheduler;
    var subject = params.subject;
    if (!subject) {
        subject = params.subject = new AsyncSubject();
        var handler = function () {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i] = arguments[_i];
            }
            var err = innerArgs.shift();
            if (err) {
                _this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                _this.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        try {
            callbackFunc.apply(context, args.concat([handler]));
        }
        catch (err) {
            this.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
        }
    }
    this.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
var OuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
var InnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        _this.index = 0;
        return _this;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */
var subscribeToPromise = function (promise) {
    return function (subscriber) {
        promise.then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, hostReportError);
        return subscriber;
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = /*@__PURE__*/ getSymbolIterator();

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
var subscribeToIterable = function (iterable) {
    return function (subscriber) {
        var iterator$1 = iterable[iterator]();
        do {
            var item = void 0;
            try {
                item = iterator$1.next();
            }
            catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) {
                break;
            }
        } while (true);
        if (typeof iterator$1.return === 'function') {
            subscriber.add(function () {
                if (iterator$1.return) {
                    iterator$1.return();
                }
            });
        }
        return subscriber;
    };
};

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
var subscribeToObservable = function (obj) {
    return function (subscriber) {
        var obs = obj[observable]();
        if (typeof obs.subscribe !== 'function') {
            throw new TypeError('Provided object does not correctly implement Symbol.observable');
        }
        else {
            return obs.subscribe(subscriber);
        }
    };
};

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function isPromise(value) {
    return !!value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}

/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */
var subscribeTo = function (result) {
    if (!!result && typeof result[observable] === 'function') {
        return subscribeToObservable(result);
    }
    else if (isArrayLike(result)) {
        return subscribeToArray(result);
    }
    else if (isPromise(result)) {
        return subscribeToPromise(result);
    }
    else if (!!result && typeof result[iterator] === 'function') {
        return subscribeToIterable(result);
    }
    else {
        var value = isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected."
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        throw new TypeError(msg);
    }
};

/** PURE_IMPORTS_START _InnerSubscriber,_subscribeTo,_Observable PURE_IMPORTS_END */
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex, innerSubscriber) {
    if (innerSubscriber === void 0) {
        innerSubscriber = new InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    }
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable) {
        return result.subscribe(innerSubscriber);
    }
    return subscribeTo(result)(innerSubscriber);
}

/** PURE_IMPORTS_START tslib,_util_isScheduler,_util_isArray,_OuterSubscriber,_util_subscribeToResult,_fromArray PURE_IMPORTS_END */
var NONE = {};
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = undefined;
    var scheduler = undefined;
    if (isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        resultSelector = observables.pop();
    }
    if (observables.length === 1 && isArray(observables[0])) {
        observables = observables[0];
    }
    return fromArray(observables, scheduler).lift(new CombineLatestOperator(resultSelector));
}
var CombineLatestOperator = /*@__PURE__*/ (function () {
    function CombineLatestOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.resultSelector));
    };
    return CombineLatestOperator;
}());
var CombineLatestSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, resultSelector) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.active = 0;
        _this.values = [];
        _this.observables = [];
        return _this;
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(NONE);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult(this, observable, undefined, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === NONE ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.resultSelector) {
                this._tryResultSelector(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryResultSelector = function (values) {
        var result;
        try {
            result = this.resultSelector.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber));

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */
function scheduleObservable(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        sub.add(scheduler.schedule(function () {
            var observable$1 = input[observable]();
            sub.add(observable$1.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function schedulePromise(input, scheduler) {
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        sub.add(scheduler.schedule(function () {
            return input.then(function (value) {
                sub.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                sub.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */
function scheduleIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new Observable(function (subscriber) {
        var sub = new Subscription();
        var iterator$1;
        sub.add(function () {
            if (iterator$1 && typeof iterator$1.return === 'function') {
                iterator$1.return();
            }
        });
        sub.add(scheduler.schedule(function () {
            iterator$1 = input[iterator]();
            sub.add(scheduler.schedule(function () {
                if (subscriber.closed) {
                    return;
                }
                var value;
                var done;
                try {
                    var result = iterator$1.next();
                    value = result.value;
                    done = result.done;
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */
function isInteropObservable(input) {
    return input && typeof input[observable] === 'function';
}

/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */
function isIterable(input) {
    return input && typeof input[iterator] === 'function';
}

/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */
function scheduled(input, scheduler) {
    if (input != null) {
        if (isInteropObservable(input)) {
            return scheduleObservable(input, scheduler);
        }
        else if (isPromise(input)) {
            return schedulePromise(input, scheduler);
        }
        else if (isArrayLike(input)) {
            return scheduleArray(input, scheduler);
        }
        else if (isIterable(input) || typeof input === 'string') {
            return scheduleIterable(input, scheduler);
        }
    }
    throw new TypeError((input !== null && typeof input || input) + ' is not observable');
}

/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */
function from(input, scheduler) {
    if (!scheduler) {
        if (input instanceof Observable) {
            return input;
        }
        return new Observable(subscribeTo(input));
    }
    else {
        return scheduled(input, scheduler);
    }
}

/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */
var SimpleInnerSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}(Subscriber));
var SimpleOuterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}(Subscriber));
function innerSubscribe(result, innerSubscriber) {
    if (innerSubscriber.closed) {
        return undefined;
    }
    if (result instanceof Observable) {
        return result.subscribe(innerSubscriber);
    }
    var subscription;
    try {
        subscription = subscribeTo(result)(innerSubscriber);
    }
    catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    if (typeof resultSelector === 'function') {
        return function (source) { return source.pipe(mergeMap(function (a, i) { return from(project(a, i)).pipe(map(function (b, ii) { return resultSelector(a, b, i, ii); })); }, concurrent)); };
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return function (source) { return source.lift(new MergeMapOperator(project, concurrent)); };
}
var MergeMapOperator = /*@__PURE__*/ (function () {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}());
var MergeMapSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) {
            concurrent = Number.POSITIVE_INFINITY;
        }
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish) {
        var innerSubscriber = new SimpleInnerSubscriber(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = innerSubscribe(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) {
            destination.add(innerSubscription);
        }
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function (innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function () {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */
function mergeAll(concurrent) {
    if (concurrent === void 0) {
        concurrent = Number.POSITIVE_INFINITY;
    }
    return mergeMap(identity, concurrent);
}

/** PURE_IMPORTS_START _mergeAll PURE_IMPORTS_END */
function concatAll() {
    return mergeAll(1);
}

/** PURE_IMPORTS_START _of,_operators_concatAll PURE_IMPORTS_END */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    return concatAll()(of.apply(void 0, observables));
}

/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
function defer(observableFactory) {
    return new Observable(function (subscriber) {
        var input;
        try {
            input = observableFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = input ? from(input) : empty();
        return source.subscribe(subscriber);
    });
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_operators_map,_util_isObject,_from PURE_IMPORTS_END */
function forkJoin() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 1) {
        var first_1 = sources[0];
        if (isArray(first_1)) {
            return forkJoinInternal(first_1, null);
        }
        if (isObject(first_1) && Object.getPrototypeOf(first_1) === Object.prototype) {
            var keys = Object.keys(first_1);
            return forkJoinInternal(keys.map(function (key) { return first_1[key]; }), keys);
        }
    }
    if (typeof sources[sources.length - 1] === 'function') {
        var resultSelector_1 = sources.pop();
        sources = (sources.length === 1 && isArray(sources[0])) ? sources[0] : sources;
        return forkJoinInternal(sources, null).pipe(map(function (args) { return resultSelector_1.apply(void 0, args); }));
    }
    return forkJoinInternal(sources, null);
}
function forkJoinInternal(sources, keys) {
    return new Observable(function (subscriber) {
        var len = sources.length;
        if (len === 0) {
            subscriber.complete();
            return;
        }
        var values = new Array(len);
        var completed = 0;
        var emitted = 0;
        var _loop_1 = function (i) {
            var source = from(sources[i]);
            var hasValue = false;
            subscriber.add(source.subscribe({
                next: function (value) {
                    if (!hasValue) {
                        hasValue = true;
                        emitted++;
                    }
                    values[i] = value;
                },
                error: function (err) { return subscriber.error(err); },
                complete: function () {
                    completed++;
                    if (completed === len || !hasValue) {
                        if (emitted === len) {
                            subscriber.next(keys ?
                                keys.reduce(function (result, key, i) { return (result[key] = values[i], result); }, {}) :
                                values);
                        }
                        subscriber.complete();
                    }
                }
            }));
        };
        for (var i = 0; i < len; i++) {
            _loop_1(i);
        }
    });
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
function fromEvent(target, eventName, options, resultSelector) {
    if (isFunction(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable(function (subscriber) {
        function handler(e) {
            if (arguments.length > 1) {
                subscriber.next(Array.prototype.slice.call(arguments));
            }
            else {
                subscriber.next(e);
            }
        }
        setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if (isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function () { return source_1.removeEventListener(eventName, handler, options); };
    }
    else if (isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function () { return source_2.off(eventName, handler); };
    }
    else if (isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function () { return source_3.removeListener(eventName, handler); };
    }
    else if (sourceObj && sourceObj.length) {
        for (var i = 0, len = sourceObj.length; i < len; i++) {
            setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
        }
    }
    else {
        throw new TypeError('Invalid event target');
    }
    subscriber.add(unsubscribe);
}
function isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}

/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(map(function (args) { return isArray(args) ? resultSelector.apply(void 0, args) : resultSelector(args); }));
    }
    return new Observable(function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue;
        try {
            retValue = addHandler(handler);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!isFunction(removeHandler)) {
            return undefined;
        }
        return function () { return removeHandler(handler, retValue); };
    });
}

/** PURE_IMPORTS_START _Observable,_util_identity,_util_isScheduler PURE_IMPORTS_END */
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
    var resultSelector;
    var initialState;
    if (arguments.length == 1) {
        var options = initialStateOrOptions;
        initialState = options.initialState;
        condition = options.condition;
        iterate = options.iterate;
        resultSelector = options.resultSelector || identity;
        scheduler = options.scheduler;
    }
    else if (resultSelectorOrObservable === undefined || isScheduler(resultSelectorOrObservable)) {
        initialState = initialStateOrOptions;
        resultSelector = identity;
        scheduler = resultSelectorOrObservable;
    }
    else {
        initialState = initialStateOrOptions;
        resultSelector = resultSelectorOrObservable;
    }
    return new Observable(function (subscriber) {
        var state = initialState;
        if (scheduler) {
            return scheduler.schedule(dispatch$4, 0, {
                subscriber: subscriber,
                iterate: iterate,
                condition: condition,
                resultSelector: resultSelector,
                state: state
            });
        }
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return undefined;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return undefined;
            }
        } while (true);
        return undefined;
    });
}
function dispatch$4(state) {
    var subscriber = state.subscriber, condition = state.condition;
    if (subscriber.closed) {
        return undefined;
    }
    if (state.needIterate) {
        try {
            state.state = state.iterate(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
    }
    else {
        state.needIterate = true;
    }
    if (condition) {
        var conditionResult = void 0;
        try {
            conditionResult = condition(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        if (!conditionResult) {
            subscriber.complete();
            return undefined;
        }
        if (subscriber.closed) {
            return undefined;
        }
    }
    var value;
    try {
        value = state.resultSelector(state.state);
    }
    catch (err) {
        subscriber.error(err);
        return undefined;
    }
    if (subscriber.closed) {
        return undefined;
    }
    subscriber.next(value);
    if (subscriber.closed) {
        return undefined;
    }
    return this.schedule(state);
}

/** PURE_IMPORTS_START _defer,_empty PURE_IMPORTS_END */
function iif(condition, trueResult, falseResult) {
    if (trueResult === void 0) {
        trueResult = EMPTY;
    }
    if (falseResult === void 0) {
        falseResult = EMPTY;
    }
    return defer(function () { return condition() ? trueResult : falseResult; });
}

/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
function isNumeric(val) {
    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
}

/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric PURE_IMPORTS_END */
function interval(period, scheduler) {
    if (period === void 0) {
        period = 0;
    }
    if (scheduler === void 0) {
        scheduler = async;
    }
    if (!isNumeric(period) || period < 0) {
        period = 0;
    }
    if (!scheduler || typeof scheduler.schedule !== 'function') {
        scheduler = async;
    }
    return new Observable(function (subscriber) {
        subscriber.add(scheduler.schedule(dispatch$3, period, { subscriber: subscriber, counter: 0, period: period }));
        return subscriber;
    });
}
function dispatch$3(state) {
    var subscriber = state.subscriber, counter = state.counter, period = state.period;
    subscriber.next(counter);
    this.schedule({ subscriber: subscriber, counter: counter + 1, period: period }, period);
}

/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable) {
        return observables[0];
    }
    return mergeAll(concurrent)(fromArray(observables, scheduler));
}

/** PURE_IMPORTS_START _Observable,_util_noop PURE_IMPORTS_END */
var NEVER = /*@__PURE__*/ new Observable(noop);
function never() {
    return NEVER;
}

/** PURE_IMPORTS_START _Observable,_from,_util_isArray,_empty PURE_IMPORTS_END */
function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    if (sources.length === 0) {
        return EMPTY;
    }
    var first = sources[0], remainder = sources.slice(1);
    if (sources.length === 1 && isArray(first)) {
        return onErrorResumeNext.apply(void 0, first);
    }
    return new Observable(function (subscriber) {
        var subNext = function () { return subscriber.add(onErrorResumeNext.apply(void 0, remainder).subscribe(subscriber)); };
        return from(first).subscribe({
            next: function (value) { subscriber.next(value); },
            error: subNext,
            complete: subNext,
        });
    });
}

/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */
function pairs(obj, scheduler) {
    if (!scheduler) {
        return new Observable(function (subscriber) {
            var keys = Object.keys(obj);
            for (var i = 0; i < keys.length && !subscriber.closed; i++) {
                var key = keys[i];
                if (obj.hasOwnProperty(key)) {
                    subscriber.next([key, obj[key]]);
                }
            }
            subscriber.complete();
        });
    }
    else {
        return new Observable(function (subscriber) {
            var keys = Object.keys(obj);
            var subscription = new Subscription();
            subscription.add(scheduler.schedule(dispatch$2, 0, { keys: keys, index: 0, subscriber: subscriber, subscription: subscription, obj: obj }));
            return subscription;
        });
    }
}
function dispatch$2(state) {
    var keys = state.keys, index = state.index, subscriber = state.subscriber, subscription = state.subscription, obj = state.obj;
    if (!subscriber.closed) {
        if (index < keys.length) {
            var key = keys[index];
            subscriber.next([key, obj[key]]);
            subscription.add(this.schedule({ keys: keys, index: index + 1, subscriber: subscriber, subscription: subscription, obj: obj }));
        }
        else {
            subscriber.complete();
        }
    }
}

/** PURE_IMPORTS_START  PURE_IMPORTS_END */
function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}

/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */
function filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new FilterOperator(predicate, thisArg));
    };
}
var FilterOperator = /*@__PURE__*/ (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
var FilterSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber));

/** PURE_IMPORTS_START _util_not,_util_subscribeTo,_operators_filter,_Observable PURE_IMPORTS_END */
function partition(source, predicate, thisArg) {
    return [
        filter(predicate, thisArg)(new Observable(subscribeTo(source))),
        filter(not(predicate, thisArg))(new Observable(subscribeTo(source)))
    ];
}

/** PURE_IMPORTS_START tslib,_util_isArray,_fromArray,_OuterSubscriber,_util_subscribeToResult PURE_IMPORTS_END */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    if (observables.length === 1) {
        if (isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return fromArray(observables, undefined).lift(new RaceOperator());
}
var RaceOperator = /*@__PURE__*/ (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
var RaceSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        var _this = _super.call(this, destination) || this;
        _this.hasFirst = false;
        _this.observables = [];
        _this.subscriptions = [];
        return _this;
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult(this, observable, undefined, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (_outerValue, innerValue, outerIndex) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber));

/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */
function range(start, count, scheduler) {
    if (start === void 0) {
        start = 0;
    }
    return new Observable(function (subscriber) {
        if (count === undefined) {
            count = start;
            start = 0;
        }
        var index = 0;
        var current = start;
        if (scheduler) {
            return scheduler.schedule(dispatch$1, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(current++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
        return undefined;
    });
}
function dispatch$1(state) {
    var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
    if (index >= count) {
        subscriber.complete();
        return;
    }
    subscriber.next(start);
    if (subscriber.closed) {
        return;
    }
    state.index = index + 1;
    state.start = start + 1;
    this.schedule(state);
}

/** PURE_IMPORTS_START _Observable,_scheduler_async,_util_isNumeric,_util_isScheduler PURE_IMPORTS_END */
function timer(dueTime, periodOrScheduler, scheduler) {
    if (dueTime === void 0) {
        dueTime = 0;
    }
    var period = -1;
    if (isNumeric(periodOrScheduler)) {
        period = Number(periodOrScheduler) < 1 && 1 || Number(periodOrScheduler);
    }
    else if (isScheduler(periodOrScheduler)) {
        scheduler = periodOrScheduler;
    }
    if (!isScheduler(scheduler)) {
        scheduler = async;
    }
    return new Observable(function (subscriber) {
        var due = isNumeric(dueTime)
            ? dueTime
            : (+dueTime - scheduler.now());
        return scheduler.schedule(dispatch, due, {
            index: 0, period: period, subscriber: subscriber
        });
    });
}
function dispatch(state) {
    var index = state.index, period = state.period, subscriber = state.subscriber;
    subscriber.next(index);
    if (subscriber.closed) {
        return;
    }
    else if (period === -1) {
        return subscriber.complete();
    }
    state.index = index + 1;
    this.schedule(state, period);
}

/** PURE_IMPORTS_START _Observable,_from,_empty PURE_IMPORTS_END */
function using(resourceFactory, observableFactory) {
    return new Observable(function (subscriber) {
        var resource;
        try {
            resource = resourceFactory();
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var result;
        try {
            result = observableFactory(resource);
        }
        catch (err) {
            subscriber.error(err);
            return undefined;
        }
        var source = result ? from(result) : EMPTY;
        var subscription = source.subscribe(subscriber);
        return function () {
            subscription.unsubscribe();
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}

/** PURE_IMPORTS_START tslib,_fromArray,_util_isArray,_Subscriber,_.._internal_symbol_iterator,_innerSubscribe PURE_IMPORTS_END */
function zip() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i] = arguments[_i];
    }
    var resultSelector = observables[observables.length - 1];
    if (typeof resultSelector === 'function') {
        observables.pop();
    }
    return fromArray(observables, undefined).lift(new ZipOperator(resultSelector));
}
var ZipOperator = /*@__PURE__*/ (function () {
    function ZipOperator(resultSelector) {
        this.resultSelector = resultSelector;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.resultSelector));
    };
    return ZipOperator;
}());
var ZipSubscriber = /*@__PURE__*/ (function (_super) {
    __extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, resultSelector, values) {
        var _this = _super.call(this, destination) || this;
        _this.resultSelector = resultSelector;
        _this.iterators = [];
        _this.active = 0;
        _this.resultSelector = (typeof resultSelector === 'function') ? resultSelector : undefined;
        return _this;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (isArray(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[iterator] === 'function') {
            iterators.push(new StaticIterator(value[iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        this.unsubscribe();
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                var destination = this.destination;
                destination.add(iterator.subscribe());
            }
            else {
                this.active--;
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.resultSelector) {
            this._tryresultSelector(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryresultSelector = function (args) {
        var result;
        try {
            result = this.resultSelector.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(Subscriber));
var StaticIterator = /*@__PURE__*/ (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return Boolean(nextResult && nextResult.done);
    };
    return StaticIterator;
}());
var StaticArrayIterator = /*@__PURE__*/ (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
var ZipBufferIterator = /*@__PURE__*/ (function (_super) {
    __extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        var _this = _super.call(this, destination) || this;
        _this.parent = parent;
        _this.observable = observable;
        _this.stillUnsubscribed = true;
        _this.buffer = [];
        _this.isComplete = false;
        return _this;
    }
    ZipBufferIterator.prototype[iterator] = function () {
        return this;
    };
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (innerValue) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function () {
        return innerSubscribe(this.observable, new SimpleInnerSubscriber(this));
    };
    return ZipBufferIterator;
}(SimpleOuterSubscriber));

/** PURE_IMPORTS_START  PURE_IMPORTS_END */

var _esm5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Observable: Observable,
    ConnectableObservable: ConnectableObservable,
    GroupedObservable: GroupedObservable,
    observable: observable,
    Subject: Subject,
    BehaviorSubject: BehaviorSubject,
    ReplaySubject: ReplaySubject,
    AsyncSubject: AsyncSubject,
    asap: asap,
    asapScheduler: asapScheduler,
    async: async,
    asyncScheduler: asyncScheduler,
    queue: queue,
    queueScheduler: queueScheduler,
    animationFrame: animationFrame,
    animationFrameScheduler: animationFrameScheduler,
    VirtualTimeScheduler: VirtualTimeScheduler,
    VirtualAction: VirtualAction,
    Scheduler: Scheduler,
    Subscription: Subscription,
    Subscriber: Subscriber,
    Notification: Notification,
    get NotificationKind () { return NotificationKind; },
    pipe: pipe,
    noop: noop,
    identity: identity,
    isObservable: isObservable,
    ArgumentOutOfRangeError: ArgumentOutOfRangeError,
    EmptyError: EmptyError,
    ObjectUnsubscribedError: ObjectUnsubscribedError,
    UnsubscriptionError: UnsubscriptionError,
    TimeoutError: TimeoutError,
    bindCallback: bindCallback,
    bindNodeCallback: bindNodeCallback,
    combineLatest: combineLatest,
    concat: concat,
    defer: defer,
    empty: empty,
    forkJoin: forkJoin,
    from: from,
    fromEvent: fromEvent,
    fromEventPattern: fromEventPattern,
    generate: generate,
    iif: iif,
    interval: interval,
    merge: merge,
    never: never,
    of: of,
    onErrorResumeNext: onErrorResumeNext,
    pairs: pairs,
    partition: partition,
    race: race,
    range: range,
    throwError: throwError,
    timer: timer,
    using: using,
    zip: zip,
    scheduled: scheduled,
    EMPTY: EMPTY,
    NEVER: NEVER,
    config: config
});

var UserAgent = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouch = exports.isFirefox = exports.isSafari = exports.isEdge = exports.isChrome = exports.isPCDevice = exports.isMac = exports.isKindle = exports.isMobileDevice = exports.isIE = exports.isAndroid = exports.isIos = void 0;

exports.isIos = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /ipad|iphone|ipod/i.test(navigator.userAgent));
});
exports.isAndroid = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent && /android/i.test(navigator.userAgent));
});
exports.isIE = utils.makeSsrSafe(function () {
    return Boolean(/MSIE|Trident/i.test(window.navigator.userAgent));
});
exports.isMobileDevice = utils.makeSsrSafe(function () {
    return Boolean(navigator.userAgent &&
        /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Silk/i.test(navigator.userAgent));
});
exports.isKindle = utils.makeSsrSafe(function () {
    return Boolean(/Silk/i.test(window.navigator.userAgent));
});
exports.isMac = utils.makeSsrSafe(function () {
    return Boolean(/Macintosh/i.test(window.navigator.userAgent));
});
exports.isPCDevice = utils.makeSsrSafe(function () {
    return Boolean(!exports.isAndroid() && !exports.isIos() && !exports.isKindle() && !exports.isMac());
});
exports.isChrome = utils.makeSsrSafe(function () {
    return Boolean(/Chrome/i.test(window.navigator.userAgent));
});
exports.isEdge = utils.makeSsrSafe(function () {
    return Boolean(/(?=.*AppleWebKit)(?=.*Safari)(?=.*Edg)/i.test(window.navigator.userAgent));
});
exports.isSafari = utils.makeSsrSafe(function () {
    return Boolean(exports.isMac && !exports.isMobileDevice && !exports.isChrome && /Safari/i.test(window.navigator.userAgent));
});
exports.isFirefox = utils.makeSsrSafe(function () {
    return Boolean(/Firefox/i.test(window.navigator.userAgent) &&
        "MozAppearance" in document.documentElement.style);
});
exports.isTouch = utils.makeSsrSafe(function () {
    return Boolean("ontouchstart" in document.documentElement);
});
});

var rxjs_1 = /*@__PURE__*/getAugmentedNamespace(_esm5);

var TabWatcher = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabWatcher = void 0;



/** The subject that will emit events when tabbing state changes */
var subject = new rxjs_1.Subject();
var isTabbing = false;
var initialized = false;
var checkFocusable = function (ele) {
    var eleArray = ["a", "button", "input", "select", "textarea", "label"];
    var eleTag = ele.nodeName.toLowerCase();
    if (eleArray.indexOf(eleTag) > -1) {
        return true;
    }
    else {
        if (ele.getAttribute("tabindex") !== null && ele.getAttribute("tabindex") !== "-1") {
            return true;
        }
        else {
            return false;
        }
    }
};
var maybeStartTabbing = function (event) {
    var key = event.which || event.keyCode || 0;
    var eleFocusable = checkFocusable(event.target);
    if ((!isTabbing && key === 9) || key === 13 || key === 32 || key === 37 || key === 38 || key === 39 || key === 40) {
        if (initialized && eleFocusable) {
            document.documentElement.classList.add("is-tabbing");
            document.documentElement.classList.remove("is-mouse");
        }
        isTabbing = true;
        subject.next(isTabbing);
    }
};
var mouseClick = function () {
    var eleFocusable = checkFocusable(document.activeElement);
    if (eleFocusable) {
        document.documentElement.classList.add("is-mouse");
        document.documentElement.classList.remove("is-tabbing");
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var stopTabbing = function () {
    if (isTabbing) {
        if (initialized) {
            document.documentElement.classList.remove("is-mouse");
            document.documentElement.classList.remove("is-tabbing");
        }
        isTabbing = false;
        subject.next(isTabbing);
    }
};
var addDeviceClass = function () {
    if (UserAgent.isAndroid()) {
        document.documentElement.classList.add("isAndroid");
    }
    if (UserAgent.isIos()) {
        document.documentElement.classList.add("isIOS");
    }
    if (UserAgent.isIE()) {
        document.documentElement.classList.add("isIE");
    }
    if (UserAgent.isMobileDevice()) {
        document.documentElement.classList.add("isMobile");
    }
    if (UserAgent.isKindle()) {
        document.documentElement.classList.add("isKindle");
    }
    if (UserAgent.isMac()) {
        document.documentElement.classList.add("isMac");
    }
    if (UserAgent.isPCDevice()) {
        document.documentElement.classList.add("isPC");
    }
    if (UserAgent.isChrome()) {
        document.documentElement.classList.add("isChrome");
    }
    if (UserAgent.isEdge()) {
        document.documentElement.classList.add("isEdge");
    }
    if (UserAgent.isSafari()) {
        document.documentElement.classList.add("isSafari");
    }
    if (UserAgent.isFirefox()) {
        document.documentElement.classList.add("isFirefox");
    }
    if (UserAgent.isTouch()) {
        document.documentElement.classList.add("isTouch");
    }
    addOrientationClass();
};
var addOrientationClass = function () {
    if (window.innerWidth < window.innerHeight) {
        document.documentElement.classList.add("isPortrait");
        document.documentElement.classList.remove("isLandscape");
    }
    if (window.innerWidth > window.innerHeight) {
        document.documentElement.classList.remove("isPortrait");
        document.documentElement.classList.add("isLandscape");
    }
};
utils.ssrSafe(function () {
    addEventListener("keyup", maybeStartTabbing);
    addEventListener("click", mouseClick);
    addEventListener("touchstart", stopTabbing);
    addEventListener("resize", addOrientationClass);
    if (document.readyState === "complete") {
        addDeviceClass();
    }
    else {
        addEventListener("DOMContentLoaded", addDeviceClass);
    }
}, [typeof addEventListener === "function"]);
var observable = subject.asObservable();
/**
 * Subscribe to this to see whenever the user starts or stops tabbing.
 */
exports.TabWatcher = {
    /** Initialize the default action (adding `is-tabbing` class to body). */
    initialize: function () {
        initialized = true;
    },
    /** Whether we are currently using tab to navigate. */
    get isTabbing() {
        return isTabbing;
    },
    /** Subscribe to this observable. */
    subscribe: observable.subscribe.bind(observable),
    /** Pipe this observable with operators. */
    pipe: observable.pipe.bind(observable),
};
});

var styles$3 = /*@__PURE__*/getAugmentedNamespace(BaseCta$3);

var BaseCta$1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakeCtaFromBase = exports.BaseCta = void 0;









TabWatcher.TabWatcher.initialize();
/** A CTA without any styling. */
exports.BaseCta = MakeCtaFromBase(function (props) { return ({ props: props, classes: styles$3.baseCta }); });
function MakeCtaFromBase(customizer) {
    if (customizer === void 0) { customizer = function (props) { return ({ props: props }); }; }
    return React__default.forwardRef(function (allProps, ref) {
        var _a = customizer(allProps), props = _a.props, classes = _a.classes, prepend = _a.prepend, append = _a.append;
        // Separate the properties that will be passed to the CTA directly. Parse the rest manually.
        var _b = Simplify.simplify(props), children = _b.children, _c = _b.onDark, onDark = _c === void 0 ? false : _c, appsDownload = _b.appsDownload, _d = _b.suppressLinkClick, suppressLinkClick = _d === void 0 ? false : _d, _e = _b.name, name = _e === void 0 ? typeof props.children === "string" ? props.children : undefined : _e, position = _b.position, url = _b.url, prefix = _b.urlPrefix, onClick = _b.onClick, className = _b.className, style = _b.style, _f = _b.openInNewWindow, openInNewWindow = _f === void 0 ? false : _f, _g = _b.link, link = _g === void 0 ? props.overrideLink ? true : !props.onClick && Boolean(props.url) : _g, _h = _b.overrideLink, overrideLink = _h === void 0 ? false : _h, _j = _b.disabled, disabled = _j === void 0 ? false : _j, deviceOptimization = _b.deviceOptimization, mediaType = _b.mediaType, download = _b.download, relationship = _b.relationship, autoFocus = _b.autoFocus, form = _b.form, _k = _b.buttonType, buttonType = _k === void 0 ? "button" : _k, formAction = _b.formAction, formEncType = _b.formEncType, formMethod = _b.formMethod, formNoValidate = _b.formNoValidate, testId = _b.testId, passthrough = __rest(_b, ["children", "onDark", "appsDownload", "suppressLinkClick", "name", "position", "url", "urlPrefix", "onClick", "className", "style", "openInNewWindow", "link", "overrideLink", "disabled", "deviceOptimization", "mediaType", "download", "relationship", "autoFocus", "form", "buttonType", "formAction", "formEncType", "formMethod", "formNoValidate", "testId"]);
        var combinedOnClick = function (event) {
            if (!suppressLinkClick && name && Reporting.ReportingHelper.initialized) {
                Reporting.ReportingHelper.linkClick({
                    name: name,
                    position: position,
                    url: url,
                    prefix: prefix,
                });
            }
            if (onClick) {
                onClick(event);
            }
        };
        var handleKeyPress = function (event) {
            if (event.keyCode === 13 || event.keyCode === 32) {
                if (onClick) {
                    combinedOnClick(event);
                }
            }
        };
        var otherProps = link
            ? {
                href: (overrideLink && url) || (!overrideLink && !disabled) ? url : undefined,
                target: openInNewWindow ? "_blank" : undefined,
                rel: relationship,
                media: deviceOptimization,
                type: mediaType,
                download: download,
            }
            : {
                autoFocus: autoFocus,
                type: buttonType,
                form: form,
                formAction: formAction,
                formEncType: formEncType,
                formMethod: formMethod,
                formNoValidate: formNoValidate,
                formTarget: openInNewWindow ? "_blank" : undefined,
            };
        var lnkRole = props.role ? { role: props.role } : { role: "button" };
        var eleRole = link ? (overrideLink && onClick ? lnkRole : "") : "";
        var Element = link ? "a" : "button";
        var myRef = React__default.useRef(null);
        React__default.useEffect(function () {
            if (link && autoFocus && myRef.current) {
                Focus.focus(myRef.current);
            }
        }, [autoFocus, link]);
        return (React__default.createElement(Element, __assign({ className: Join.join(onDark && BaseCtaProps.Classes.onDark, link && disabled && BaseCtaProps.Classes.disabled, className, classes, appsDownload === "google-lg" ? "" + styles$3.googlePlayLg : "", appsDownload === "apple-lg" ? "" + styles$3.appleAppStoreLg : "", appsDownload === "google-sm" ? "" + styles$3.googlePlaySm : "", appsDownload === "apple-sm" ? "" + styles$3.appleAppStoreSm : ""), "data-testid": testId, disabled: (!link && disabled) || undefined, onClick: combinedOnClick, style: style, ref: Refs.refs(myRef, ref) }, { tabIndex: overrideLink ? 0 : undefined }, {
            onKeyDown: link
                ? overrideLink && onClick
                    ? handleKeyPress
                    : undefined
                : undefined,
        }, passthrough, eleRole, otherProps),
            prepend,
            link && (prepend !== "" || append !== "") ? React__default.createElement("span", null, children) : children,
            overrideLink && openInNewWindow && (React__default.createElement("span", { className: "hidden-spoken" }, " (opens in a new window)")),
            append));
    });
}
exports.MakeCtaFromBase = MakeCtaFromBase;
});

var BaseCta = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(BaseCta$1, exports);
__exportStar(BaseCtaProps, exports);
var BaseCta_1 = BaseCta$1;
exports.default = BaseCta_1.BaseCta;
});

var css_248z$6 = ".link-icon-left,\n.link-icon-right {\n  display: inline-flex;\n  align-items: center; }\n\n.link-icon-left span,\n.link-icon-right span {\n  border-bottom: 1px solid transparent; }\n\n.link-icon-left svg,\n.link-icon-right svg {\n  flex-shrink: 0; }\n\n.link-icon-left:hover,\n.link-icon-right:hover {\n  color: #0057b8;\n  text-decoration: none; }\n\n.link-icon-left:hover span,\n.link-icon-right:hover span {\n  border-bottom: 1px solid #0057b8; }\n\n.link-icon-left.type-base svg,\n.link-icon-right.type-base svg {\n  width: 20px;\n  height: 20px; }\n\n.link-icon-left.type-sm svg,\n.link-icon-right.type-sm svg {\n  width: 16px;\n  height: 16px; }\n\n.link-icon-left.type-xs svg,\n.link-icon-right.type-xs svg {\n  width: 16px;\n  height: 16px; }\n\n.link-icon-left.type-base svg {\n  margin-right: 6px; }\n\n.link-icon-right.type-base svg {\n  margin-left: 6px; }\n\n.link-icon-left.type-sm svg,\n.link-icon-left.type-xs svg {\n  margin-right: 5px; }\n\n.link-icon-right.type-sm svg,\n.link-icon-right.type-xs svg {\n  margin-left: 5px; }\n\n.link-icon-left.color-ui-white:hover,\n.link-icon-right.color-ui-white:hover {\n  color: #fff; }\n\n.link-icon-left.color-ui-white:hover span,\n.link-icon-right.color-ui-white:hover span {\n  border-color: #fff; }\n";
styleInject(css_248z$6);

var LinkProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kind = void 0;
(function (Kind) {
    /** A link that is blue on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilityPrimary"] = "link-utility-primary";
    /** A link that is dark gray on light backgrounds or white on dark backgrounds, with a rightward caret. */
    Kind["utilitySecondary"] = "link-utility-secondary";
    /** A small link with a rightward arrow. */
    Kind["tertiarySmall"] = "link-tertiary-small";
    /** A large link with a rightward arrow. */
    Kind["tertiaryLarge"] = "link-tertiary-large";
    /** A text link with an underline. */
    Kind["textUnderline"] = "link-text";
    /** A text link with medium font. */
    Kind["textMedium"] = "link-text2";
    /** A text link without any distinguishing features. Use this very sparingly. As in almost never. */
    Kind["textPlain"] = "link-text3";
    /** A link with Icon prepended before text. */
    Kind["withPrependIcon"] = "link-icon-left";
    /** A link with Icon appended after text. */
    Kind["withAppendIcon"] = "link-icon-right";
    /** A link no default classes */
    Kind["none"] = "";
})(exports.Kind || (exports.Kind = {}));
});

var Link_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });




/**
 * A CTA that looks like a link. Will use `<a>` or `<button>` under the hood depending on the functionality needed.
 */
var Link = BaseCta.MakeCtaFromBase(function (allProps) {
    var _a = Simplify.simplify(allProps), _b = _a.kind, kind = _b === void 0 ? "utilityPrimary" : _b, icon = _a.icon, props = __rest(_a, ["kind", "icon"]);
    return {
        prepend: kind === "withPrependIcon" ? icon : "",
        append: kind === "withAppendIcon" ? icon : "",
        classes: [
            LinkProps.Kind[kind],
            kind === "withPrependIcon" || kind === "withAppendIcon"
                ? allProps.onDark
                    ? "line-h-md color-ui-white font-medium"
                    : "line-h-md color-cobalt font-medium"
                : "",
        ],
        props: __assign(__assign({}, props), { className: allProps.className, overrideLink: true, role: allProps.role ? allProps.role : undefined }),
    };
});
exports.default = Link;
});

var Link = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = Link_1.default;
});

var Link$1 = /*@__PURE__*/getDefaultExportFromCjs(Link);

var loader = "Spinner_loader__hOL5_";
var loaderSvg = "Spinner_loader-svg__2u4nu";
var path = "Spinner_path__RGmnF";
var loadingSpinner = "Spinner_loading-spinner__1h7j5";
var loadingSpinnerInner = "Spinner_loading-spinner-inner__m1_BN";
var loadingSpinnerOuter = "Spinner_loading-spinner-outer__1wdhB";
var css_248z$5 = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.Spinner_loader__hOL5_ {\n  flex-flow: column;\n  margin: 0 auto; }\n  .Spinner_loader__hOL5_ .Spinner_loader-svg__2u4nu:not(:last-child) {\n    margin-bottom: 10px; }\n\n.Spinner_loader-svg__2u4nu {\n  height: 42px; }\n\n[disabled] > .Spinner_loader__hOL5_ .Spinner_path__RGmnF,\n.disabled > .Spinner_loader__hOL5_ .Spinner_path__RGmnF {\n  stroke: #ffffff;\n  opacity: 0.56; }\n\n.btn-primary-2:not([disabled]):not(.disabled) > .Spinner_loader__hOL5_ .Spinner_path__RGmnF {\n  stroke: #f2f2f2; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .Spinner_loading-spinner__1h7j5 {\n    -webkit-animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n            animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n    transform-origin: center center; } }\n\n.Spinner_loading-spinner__1h7j5 g {\n  -webkit-animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n          animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n  transform-origin: center center; }\n\n.Spinner_loading-spinner-inner__m1_BN {\n  stroke-width: 3;\n  stroke: #878c94;\n  opacity: 0.25; }\n\n.Spinner_loading-spinner-outer__1wdhB {\n  stroke-width: 3;\n  stroke-dasharray: 89, 200;\n  stroke-dashoffset: 0;\n  stroke: #009fdb;\n  -webkit-animation: Spinner_loading-spinner-outer__1wdhB 1.6875s ease-in-out infinite;\n          animation: Spinner_loading-spinner-outer__1wdhB 1.6875s ease-in-out infinite;\n  stroke-linecap: round; }\n\n@-webkit-keyframes Spinner_loading-spinner__1h7j5 {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes Spinner_loading-spinner__1h7j5 {\n  100% {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes Spinner_loading-spinner-outer__1wdhB {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n\n@keyframes Spinner_loading-spinner-outer__1wdhB {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n";
var Spinner$1 = {"loader":"Spinner_loader__hOL5_","loader-svg":"Spinner_loader-svg__2u4nu","path":"Spinner_path__RGmnF","loading-spinner":"Spinner_loading-spinner__1h7j5","loading-spinner-inner":"Spinner_loading-spinner-inner__m1_BN","loading-spinner-outer":"Spinner_loading-spinner-outer__1wdhB","loaderSvg":"Spinner_loader-svg__2u4nu","loadingSpinner":"Spinner_loading-spinner__1h7j5","loadingSpinnerInner":"Spinner_loading-spinner-inner__m1_BN","loadingSpinnerOuter":"Spinner_loading-spinner-outer__1wdhB"};
var stylesheet$3="/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.Spinner_loader__hOL5_ {\n  flex-flow: column;\n  margin: 0 auto; }\n  .Spinner_loader__hOL5_ .Spinner_loader-svg__2u4nu:not(:last-child) {\n    margin-bottom: 10px; }\n\n.Spinner_loader-svg__2u4nu {\n  height: 42px; }\n\n[disabled] > .Spinner_loader__hOL5_ .Spinner_path__RGmnF,\n.disabled > .Spinner_loader__hOL5_ .Spinner_path__RGmnF {\n  stroke: #ffffff;\n  opacity: 0.56; }\n\n.btn-primary-2:not([disabled]):not(.disabled) > .Spinner_loader__hOL5_ .Spinner_path__RGmnF {\n  stroke: #f2f2f2; }\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .Spinner_loading-spinner__1h7j5 {\n    -webkit-animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n            animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n    transform-origin: center center; } }\n\n.Spinner_loading-spinner__1h7j5 g {\n  -webkit-animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n          animation: Spinner_loading-spinner__1h7j5 2.25s linear infinite;\n  transform-origin: center center; }\n\n.Spinner_loading-spinner-inner__m1_BN {\n  stroke-width: 3;\n  stroke: #878c94;\n  opacity: 0.25; }\n\n.Spinner_loading-spinner-outer__1wdhB {\n  stroke-width: 3;\n  stroke-dasharray: 89, 200;\n  stroke-dashoffset: 0;\n  stroke: #009fdb;\n  -webkit-animation: Spinner_loading-spinner-outer__1wdhB 1.6875s ease-in-out infinite;\n          animation: Spinner_loading-spinner-outer__1wdhB 1.6875s ease-in-out infinite;\n  stroke-linecap: round; }\n\n@-webkit-keyframes Spinner_loading-spinner__1h7j5 {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes Spinner_loading-spinner__1h7j5 {\n  100% {\n    transform: rotate(360deg); } }\n\n@-webkit-keyframes Spinner_loading-spinner-outer__1wdhB {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n\n@keyframes Spinner_loading-spinner-outer__1wdhB {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px; }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px; } }\n";
styleInject(css_248z$5);

var Spinner$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    loader: loader,
    loaderSvg: loaderSvg,
    path: path,
    loadingSpinner: loadingSpinner,
    loadingSpinnerInner: loadingSpinnerInner,
    loadingSpinnerOuter: loadingSpinnerOuter,
    'default': Spinner$1,
    stylesheet: stylesheet$3
});

var styles$2 = /*@__PURE__*/getAugmentedNamespace(Spinner$2);

var Spinner_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });



var Spinner = function (_a) {
    var children = _a.children, className = _a.className, style = _a.style, onDark = _a.onDark, testId = _a.testId;
    var svg = (React__default.createElement("svg", __assign({ viewBox: "0 0 43 43", className: Join.join([className, styles$2.loadingSpinner, "flex", "flex-items-center"], styles$2.loaderSvg, styles$2.loader) }, (!children
        ? {
            style: style,
        }
        : {})),
        React__default.createElement("g", null,
            React__default.createElement("circle", { className: styles$2.loadingSpinnerInner, r: "20", cx: "21.5", cy: "21.5", fill: "none" }),
            React__default.createElement("circle", { className: styles$2.loadingSpinnerOuter, r: "20", cx: "21.5", cy: "21.5", fill: "none" }))));
    return children ? (React__default.createElement("div", { className: Join.join(className, styles$2.loader, "flex", "flex-items-center", "color-ui-dark-gray", onDark && "color-ui-gray"), "data-testid": testId, style: style },
        svg,
        React__default.createElement("span", { className: "type-sm-2 font-medium line-h-lg" }, children))) : (svg);
};
exports.default = Spinner;
});

var SpinnerProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
});

var Spinner = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Spinner_1, exports);
__exportStar(SpinnerProps, exports);
var Spinner_1$1 = Spinner_1;
exports.default = Spinner_1$1.default;
});

var css_248z$4 = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n[class*=\" btn-\"] svg,\n[class^=\"btn-\"] svg {\n  height: 24px; }\n\n[class*=\" btn-\"] > *:not(.add-margin-right),\n[class^=\"btn-\"] > *:not(.add-margin-right) {\n  margin: 0 !important; }\n\n[class*=\" btn-\"] > .add-margin-right,\n[class^=\"btn-\"] > .add-margin-right {\n  margin: 0 16px 0 0; }\n\n[class*=\" btn-\"].btn-small svg,\n[class^=\"btn-\"].btn-small svg {\n  height: 18px; }\n\n[class*=\" btn-\"].btn-small .add-margin-right,\n[class^=\"btn-\"].btn-small .add-margin-right {\n  margin: 0 12px 0 0; }\n\n@media (max-width: 767px) {\n  [class*=\" btn-\"]:not(.btn-large) svg,\n  [class^=\"btn-\"]:not(.btn-large) svg {\n    height: 18px; }\n  [class*=\" btn-\"]:not(.btn-large) .add-margin-right,\n  [class^=\"btn-\"]:not(.btn-large) .add-margin-right {\n    margin: 0 12px 0 0; } }\n\n[class*=\" btn-\"][disabled] svg, [class*=\" btn-\"].disabled svg,\n[class^=\"btn-\"][disabled] svg,\n[class^=\"btn-\"].disabled svg {\n  fill: #878c94 !important; }\n\n.btn-primary svg,\n.btn-primary-2 svg {\n  fill: #ffffff; }\n\n.btn-secondary svg {\n  fill: #1d2329; }\n\n.btn-secondary:hover svg, .btn-secondary:focus svg {\n  fill: #ffffff; }\n\n.on-dark.btn-primary svg {\n  fill: #1d2329; }\n\n.on-dark.btn-primary-2 svg, .on-dark.btn-secondary svg {\n  fill: #ffffff; }\n\n.on-dark.btn-secondary:hover svg, .on-dark.btn-secondary:focus svg {\n  fill: #1d2329; }\n";
styleInject(css_248z$4);

var ButtonProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.Classes = exports.Kind = exports.Size = void 0;
(function (Size) {
    /** Large at all viewport widths. */
    Size["large"] = "btn-large";
    /** Large on desktop and tablet viewport widths; small on mobile viewport widths. */
    Size["responsive"] = "";
    /** Small at all viewport widths. */
    Size["small"] = "btn-small";
})(exports.Size || (exports.Size = {}));
(function (Kind) {
    /** Black on a light background; white on a dark background. */
    Kind["primaryBlack"] = "btn-primary";
    /** Blue on light and dark backgrounds. */
    Kind["primaryBlue"] = "btn-primary-2";
    /** White on a light background; black on a dark background. */
    Kind["secondary"] = "btn-secondary";
})(exports.Kind || (exports.Kind = {}));
(function (Classes) {
    /** Show the rightward arrow. */
    Classes["arrow"] = "btn-arrow";
    /** Span the width of its containing element. */
    Classes["fullWidth"] = "btn-full-width";
    Classes["icon"] = "add-margin-right";
})(exports.Classes || (exports.Classes = {}));
});

var Button_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (commonjsGlobal && commonjsGlobal.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });






/**
 * A CTA that looks like a button. Will use `<button>` or `<a>` under the hood depending on the functionality needed.
 */
var Button = BaseCta.MakeCtaFromBase(function (allProps) {
    var _a = Simplify.simplify(allProps), _b = _a.arrow, arrow = _b === void 0 ? false : _b, icon = _a.icon, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.kind, kind = _d === void 0 ? "primaryBlack" : _d, _e = _a.size, size = _e === void 0 ? "responsive" : _e, _f = _a.spinner, spinner = _f === void 0 ? false : _f, props = __rest(_a, ["arrow", "icon", "fullWidth", "kind", "size", "spinner"]);
    var accessoryClass = allProps.children && "add-margin-right";
    return {
        prepend: spinner ? (React__default.createElement(Spinner.default, { "aria-hidden": Boolean(allProps.children), className: accessoryClass })) : (!arrow && icon),
        classes: [
            ButtonProps.Size[size],
            ButtonProps.Kind[kind],
            fullWidth && ButtonProps.Classes.fullWidth,
            !spinner && arrow && ButtonProps.Classes.arrow,
        ],
        props: __assign(__assign({}, props), { role: "button" }),
    };
});
exports.default = Button;
});

var Button = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Button_1, exports);
__exportStar(ButtonProps, exports);
var Button_1$1 = Button_1;
exports.default = Button_1$1.default;
});

var Button$1 = /*@__PURE__*/getDefaultExportFromCjs(Button);

var css_248z$3 = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n[class=\"svg-base\"] {\n  fill: currentColor !important; }\n\n:not([class*=\"color-\"]) [class=\"svg-accent\"] {\n  fill: currentColor; }\n\n[class*=\"svg-accent-att-blue\"] [class=\"svg-accent\"] {\n  fill: #009fdb; }\n";
styleInject(css_248z$3);

var IconSvg_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (commonjsGlobal && commonjsGlobal.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (commonjsGlobal && commonjsGlobal.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });


var IconSvg = /** @class */ (function (_super) {
    __extends(IconSvg, _super);
    function IconSvg(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var svgUrl = _this.props.svgUrl;
            if (svgUrl) {
                _this.getIconFromUrl();
            }
        };
        _this.getIconFromUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var svgUrl, response, svgMarkUp, svgContent, viewBoxVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        svgUrl = this.props.svgUrl;
                        return [4 /*yield*/, fetch(svgUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        svgMarkUp = _a.sent();
                        svgContent = this.getIconContent(svgMarkUp);
                        viewBoxVal = this.getViewBoxVal(svgMarkUp);
                        this.setState({ svgContent: svgContent, viewBoxVal: viewBoxVal });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderIconFromStr = function () {
            var svgNodeStr = _this.props.svgNodeStr;
            if (svgNodeStr) {
                var svgContent = _this.getIconContent(svgNodeStr);
                var viewBoxVal = _this.getViewBoxVal(svgNodeStr);
                return _this.renderSvg(svgContent, viewBoxVal);
            }
            return null;
        };
        _this.getIconContent = function (svgNode) {
            var trimmedStr = svgNode.trim();
            var index = trimmedStr.indexOf("><");
            var returnStr = trimmedStr.substring(index + 1, trimmedStr.length - 6);
            return returnStr;
        };
        _this.getViewBoxVal = function (svgFromSource) {
            var splitA = svgFromSource.split('viewBox="');
            var splitB = splitA[1].split('"');
            var viewBoxVal = splitB[0];
            return viewBoxVal;
        };
        _this.renderSvg = function (svgContent, viewBoxVal) {
            var _a = _this.props, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, className = _a.className, colorClass = _a.colorClass, pictogramAccent = _a.pictogramAccent, pictogramDarkBg = _a.pictogramDarkBg, size = _a.size;
            var iconClass = colorClass;
            if (pictogramAccent) {
                iconClass = "svg-accent-att-blue " + (pictogramDarkBg ? "color-ui-white" : "color-black");
            }
            return (React__default.createElement("svg", { "aria-hidden": ariaHidden !== false, "aria-label": ariaHidden !== false ? undefined : ariaLabel, className: "inline-block " + iconClass + (className ? " " + className : ""), focusable: !(ariaHidden !== false), role: ariaHidden !== false ? undefined : "img", height: size ? size + "px" : undefined, width: size ? size + "px" : undefined, viewBox: viewBoxVal, dangerouslySetInnerHTML: {
                    __html: svgContent,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, svgNodeStr = _a.svgNodeStr, svgUrl = _a.svgUrl;
            if (svgUrl) {
                var _b = _this.state, svgContent = _b.svgContent, viewBoxVal = _b.viewBoxVal;
                if (svgContent && viewBoxVal) {
                    return _this.renderSvg(svgContent, viewBoxVal);
                }
            }
            else if (svgNodeStr && svgNodeStr.trim().substring(1, 4) === "svg") {
                return _this.renderIconFromStr();
            }
            return null;
        };
        _this.state = {
            svgContent: null,
            viewBoxVal: null,
        };
        return _this;
    }
    return IconSvg;
}(React__default.PureComponent));
exports.default = IconSvg;
});

var IconSvg = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = IconSvg_1.default;
});

var showHidePasswordButton = "TextField_showHidePasswordButton__2kBrj";
var showHideEyePasswordButton = "TextField_showHideEyePasswordButton__1Cwl9";
var css_248z$2 = ".TextField_showHidePasswordButton__2kBrj {\n  top: 35px;\n  background-color: transparent;\n  border: none;\n  right: 8px;\n  font-size: 14px;\n  font-weight: 500; }\n\n.TextField_showHideEyePasswordButton__1Cwl9 {\n  top: 32px;\n  background-color: transparent;\n  border: none;\n  right: 0;\n  font-size: 30px;\n  height: 41px;\n  line-height: 0; }\n\nbody.is-tabbing .TextField_showHidePasswordButton__2kBrj:focus {\n  text-decoration: underline; }\n\ninput::-ms-reveal {\n  display: none; }\n";
var TextField$2 = {"showHidePasswordButton":"TextField_showHidePasswordButton__2kBrj","showHideEyePasswordButton":"TextField_showHideEyePasswordButton__1Cwl9"};
var stylesheet$2=".TextField_showHidePasswordButton__2kBrj {\n  top: 35px;\n  background-color: transparent;\n  border: none;\n  right: 8px;\n  font-size: 14px;\n  font-weight: 500; }\n\n.TextField_showHideEyePasswordButton__1Cwl9 {\n  top: 32px;\n  background-color: transparent;\n  border: none;\n  right: 0;\n  font-size: 30px;\n  height: 41px;\n  line-height: 0; }\n\nbody.is-tabbing .TextField_showHidePasswordButton__2kBrj:focus {\n  text-decoration: underline; }\n\ninput::-ms-reveal {\n  display: none; }\n";
styleInject(css_248z$2);

var TextField$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    showHidePasswordButton: showHidePasswordButton,
    showHideEyePasswordButton: showHideEyePasswordButton,
    'default': TextField$2,
    stylesheet: stylesheet$2
});

var TextFieldProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.MASK_CHARACTER = exports.TextFieldType = void 0;
(function (TextFieldType) {
    TextFieldType["DATE"] = "date";
    TextFieldType["EMAIL"] = "email";
    TextFieldType["HIDDEN"] = "hidden";
    TextFieldType["INTEGER"] = "integer";
    TextFieldType["NUMBER"] = "number";
    TextFieldType["NUMERIC_PASSWORD"] = "numeric";
    TextFieldType["PASSWORD"] = "password";
    TextFieldType["TEL"] = "tel";
    TextFieldType["TEXT"] = "text";
})(exports.TextFieldType || (exports.TextFieldType = {}));
(function (MASK_CHARACTER) {
    MASK_CHARACTER["DEFAULT"] = "\u2022";
})(exports.MASK_CHARACTER || (exports.MASK_CHARACTER = {}));
});

var textfieldStyles = /*@__PURE__*/getAugmentedNamespace(TextField$3);

var TextField_1 = createCommonjsModule(function (module, exports) {
var __extends = (commonjsGlobal && commonjsGlobal.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });




var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentTextValue: _this.props.data.input ? _this.props.data.input : "",
            disabled: _this.props.options.disabled || false,
            maskedValue: _this.props.data.input ? _this.mask(_this.props.data.input) : "",
            showHint: false,
            showPassword: false,
        };
        _this.onChange = function (event) {
            var events = _this.props.events;
            var value = _this.evaluateValue(event);
            _this.setState({
                currentTextValue: value,
                maskedValue: _this.mask(event.currentTarget.value),
            });
            event.currentTarget.value = value;
            if (events && events.onChange) {
                events.onChange(event);
            }
        };
        _this.onMouseDown = function (event) {
            var _a = _this.props; _a.events; var options = _a.options;
            if (options.disableCopyPaste) {
                event.preventDefault();
            }
        };
        _this.onKeyPress = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if (options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD &&
                (event.charCode <= 47 || event.charCode >= 58) &&
                event.which !== 8 &&
                event.which !== 9
                && (event.which <= 95 || event.which >= 106 && event.which !== 37 && event.which !== 39 && event.which !== 46)) {
                event.preventDefault();
            }
            else if (events && events.onKeyPress) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyPress(currentTextValue, event);
            }
        };
        _this.onKeyDown = function (event) {
            var _a = _this.props, events = _a.events, options = _a.options;
            if ((options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD &&
                (event.which <= 47 || event.which >= 58) &&
                event.which !== 8 &&
                event.which !== 9
                && (event.which <= 95 || event.which >= 106) && event.which !== 37 && event.which !== 39 && event.which !== 46) ||
                (options.disableCopyPaste &&
                    event.ctrlKey &&
                    (event.keyCode === 88 || event.keyCode === 67 || event.keyCode === 86))) {
                event.preventDefault();
            }
            else if (events && events.onKeyDown) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyDown(currentTextValue, event);
            }
        };
        _this.onKeyUp = function (event) {
            var events = _this.props.events;
            if (events && events.onKeyUp) {
                var currentTextValue = _this.state.currentTextValue;
                events.onKeyUp(currentTextValue, event);
            }
        };
        _this.onBlur = function () {
            var _a = _this.props, data = _a.data, events = _a.events;
            if (data.hintText) {
                _this.setState({ showHint: false });
            }
            if (events && events.onBlur) {
                var currentTextValue = _this.state.currentTextValue;
                events.onBlur(currentTextValue);
            }
        };
        _this.onFocus = function (event) {
            var _a = _this.props, data = _a.data, events = _a.events;
            if (data.hintText) {
                _this.setState({ showHint: true });
            }
            if (events && events.onFocus) {
                var currentTextValue = _this.state.currentTextValue;
                events.onFocus(currentTextValue, event);
            }
        };
        _this.prevent = function (event) {
            var _a = _this.props; _a.events; var options = _a.options;
            if (options.disableCopyPaste) {
                event.preventDefault();
            }
        };
        _this.getContainerClass = function () {
            var options = _this.props.options;
            return options.withTooltip
                ? ["rel", options.type === TextFieldProps.TextFieldType.PASSWORD].join(" ")
                : "rel";
        };
        _this.handleShowHidePassword = function () {
            _this.setState(function (_a) {
                var showPassword = _a.showPassword;
                return ({ showPassword: !showPassword });
            });
        };
        _this.render = function () {
            var _a = _this.props, data = _a.data, id = _a.id, options = _a.options, spi = _a.spi, testId = _a.testId;
            var _b = _this.state, disabled = _b.disabled, showHint = _b.showHint, showPassword = _b.showPassword;
            var inputClasses = ["textfield", _this.props.options.className];
            if (options.error) {
                inputClasses.push("error");
            }
            var showHidePassword = options && options.showHidePassword;
            var showHideEyePassword = options && options.hasEye;
            var errorInlineText = options.error
                ? options.errorText
                : data.hintText;
            if (errorInlineText && _this.props.options.inLineHtmlParse) {
                errorInlineText = errorInlineText.replace(/ /g, "&nbsp;");
            }
            return (React__default.createElement("div", { className: "form-row " + _this.getContainerClass(), "data-testid": testId },
                data.labelText && (React__default.createElement("div", { className: "inline-flex" },
                    React__default.createElement("label", { className: "formfield-label " +
                            (options.error ? "error" : "") +
                            (disabled ? "disabled" : ""), dangerouslySetInnerHTML: { __html: data.labelText }, htmlFor: id }),
                    React__default.createElement("span", { className: "hidden-spoken" }, options.error ? options.errorText : data.hintText),
                    options.tooltip !== undefined && options.tooltip)),
                React__default.createElement("input", { "aria-label": _this.props.options.accessibility ?
                        _this.props.options.accessibility : undefined, "aria-describedby": _this.props.data.ariaDescribedBy ?
                        _this.props.data.ariaDescribedBy :
                        ((_this.props.data.hintText && !_this.props.options.error) ||
                            (_this.props.options.error && _this.props.options.errorText)
                            ? "msg_" + id
                            : undefined), "aria-invalid": options.error === true ? options.error : undefined, autoComplete: options.autocompleteOption, className: inputClasses.join(" "), "data-spi": spi, disabled: disabled, id: id, maxLength: options.maxLength, name: data.name, onBlur: _this.onBlur, onChange: _this.onChange, onFocus: _this.onFocus, onKeyDown: _this.onKeyDown, onKeyPress: _this.onKeyPress, onKeyUp: _this.onKeyUp, onPaste: _this.prevent, placeholder: data.placeHolder, ref: function (el) { return (_this.inputEl = el); }, type: _this.decideInputType(), value: _this.referenceState(), inputMode: options.inputMode ? options.inputMode : undefined }),
                _this.props.options.error && _this.props.options.errorText && (React__default.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: _this.props.options.inLineHtmlParse === true
                        ? { __html: errorInlineText }
                        : undefined, id: "msg_" + id, role: "alert", tabIndex: showHint ? 0 : -1 }, _this.props.options.inLineHtmlParse === true ? null : errorInlineText)),
                showHidePassword && (React__default.createElement("button", { "aria-label": showPassword ? "Hide Text" : "Show Text", className: [
                        textfieldStyles.showHidePasswordButton,
                        "absolute",
                        "pad-xxs",
                        "font-regular",
                        "color-ui-black",
                    ].join(" "), onClick: _this.handleShowHidePassword, tabIndex: 0, type: "button" }, !showPassword ? "Show" : "Hide")),
                showHideEyePassword && (React__default.createElement("button", { "aria-label": showPassword ? "Hide Text" : "Show Text", className: [
                        textfieldStyles.showHideEyePasswordButton,
                        "absolute",
                        "pad-xxs",
                    ].join(" "), onClick: _this.handleShowHidePassword, tabIndex: 0, style: { width: "2em" }, type: "button" },
                    showPassword === true && (React__default.createElement(IconSvg.default, { colorClass: "color-ui-black", size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M11.77 8.94l-1.5-1.5a12.28 12.28 0 0114.35 2.14L31 16l-6 6.13-1.41-1.42 4.6-4.71-5-5A10.08 10.08 0 0016 8a10.27 10.27 0 00-4.23.94zm9.64 9.64a6 6 0 00-8-8L15 12.15a3.81 3.81 0 011-.15 4 4 0 014 4 3.81 3.81 0 01-.15 1zm7.24 10.07l-1.42 1.41-5.47-5.47a12.21 12.21 0 01-14.41-2.16L1 16l6.07-6.1-5.13-5.13 1.41-1.42 5.21 5.21L10 10l1.77 1.77 1.41 1.41 5.66 5.66 1.41 1.41L22 22l1.43 1.43zM12 16a4 4 0 004 4 3.81 3.81 0 001-.15L12.15 15a3.81 3.81 0 00-.15 1zm8.26 7.09l-1.68-1.68a6 6 0 01-8-8l-2.1-2.1L3.81 16l5 5a10.17 10.17 0 0011.49 2.07z\"/></svg>" })),
                    showPassword === false && (React__default.createElement(IconSvg.default, { colorClass: "color-ui-black", size: 24, svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M24.62 9.58a12.24 12.24 0 00-17.24 0L1 16l6.36 6.43a12.19 12.19 0 0017.3 0L31 16zM23.23 21a10.19 10.19 0 01-14.46 0l-5-5 5-5a10.21 10.21 0 0114.4 0l5 5zM16 10a6 6 0 106 6 6 6 0 00-6-6zm0 10a4 4 0 114-4 4 4 0 01-4 4z\"/></svg>" })))),
                _this.props.data.hintText && !_this.props.options.error && (React__default.createElement("div", { className: "formfield-msg", dangerouslySetInnerHTML: _this.props.options.inLineHtmlParse === true
                        ? { __html: data.hintText ? data.hintText : "" }
                        : undefined, id: "msg_" + id, tabIndex: showHint ? 0 : -1 }, _this.props.options.inLineHtmlParse === true ? null : data.hintText))));
        };
        return _this;
    }
    TextField.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        var options = this.props.options;
        var _a = this.state, currentTextValue = _a.currentTextValue, disabled = _a.disabled;
        if (newProps.data.input !== currentTextValue) {
            if (options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD) {
                this.setState({
                    currentTextValue: newProps.data.input,
                    maskedValue: this.mask(newProps.data.input),
                });
            }
            else {
                this.setState({
                    currentTextValue: newProps.data.input,
                });
            }
        }
        if (newProps.options.disabled !== disabled) {
            this.setState({ disabled: newProps.options.disabled });
        }
    };
    TextField.prototype.evaluateValue = function (event) {
        var options = this.props.options;
        var currentTextValue = this.state.currentTextValue;
        var stateValue = currentTextValue ? currentTextValue : "";
        var evaluatedResult = event.currentTarget.value;
        if (options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD && !this.state.showPassword) {
            var value = event.currentTarget.value;
            var charAt = event.currentTarget.selectionStart;
            // delete key handling
            if (value.length < stateValue.length && charAt) {
                evaluatedResult = stateValue.replace(stateValue.charAt(charAt), '');
            }
            else {
                if (charAt && value.length === charAt) {
                    evaluatedResult = stateValue + value.charAt(value.length - 1);
                }
                else if (charAt) {
                    evaluatedResult = stateValue.slice(0, charAt - 1) + value.charAt(value.length - (value.length - charAt) - 1) +
                        stateValue.slice(charAt - 1);
                }
                else {
                    evaluatedResult = stateValue;
                }
            }
        }
        return evaluatedResult;
    };
    TextField.prototype.decideInputType = function () {
        var options = this.props.options;
        var showPassword = this.state.showPassword;
        var inputType = this.props.options.type;
        switch (options.type) {
            case TextFieldProps.TextFieldType.NUMERIC_PASSWORD:
                if (showPassword && options.showHidePassword) {
                    inputType = TextFieldProps.TextFieldType.TEL;
                }
                else {
                    inputType = TextFieldProps.TextFieldType.PASSWORD;
                }
                break;
            case TextFieldProps.TextFieldType.PASSWORD:
                if ((showPassword && options.showHidePassword) ||
                    (showPassword && options.hasEye)) {
                    inputType = TextFieldProps.TextFieldType.TEXT;
                }
                break;
        }
        return inputType;
    };
    TextField.prototype.mask = function (value) {
        var maskedValue = "";
        if (value && value !== "") {
            maskedValue = value.replace(/[0-9]/g, TextFieldProps.MASK_CHARACTER.DEFAULT);
        }
        return maskedValue;
    };
    TextField.prototype.referenceState = function () {
        var options = this.props.options;
        var _a = this.state, currentTextValue = _a.currentTextValue, maskedValue = _a.maskedValue, showPassword = _a.showPassword;
        return options.type === TextFieldProps.TextFieldType.NUMERIC_PASSWORD && showPassword === false
            ? maskedValue
            : currentTextValue;
    };
    TextField.defaultProps = {
        options: {
            autocompleteOption: "on",
            className: "",
            type: TextFieldProps.TextFieldType.TEXT,
        },
        spi: false,
    };
    return TextField;
}(React__default.Component));
exports.default = TextField;
});

var TextField = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = TextField_1.default;
});

var TextField$1 = /*@__PURE__*/getDefaultExportFromCjs(TextField);

var hrule = "HorizontalRule_hrule__3XaEt";
var css_248z$1 = ".HorizontalRule_hrule__3XaEt {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  padding: 0;\n  border: none;\n  position: relative;\n  min-height: 1px; }\n\n.HorizontalRule_hrule__3XaEt:before {\n  align-self: center;\n  background-color: #dcdfe3;\n  content: \"\";\n  display: flex;\n  height: 1px;\n  width: 100%;\n  position: absolute; }\n\n.HorizontalRule_hrule__3XaEt:after {\n  align-self: center;\n  background-color: #ffffff;\n  content: attr(aria-label);\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: center;\n  z-index: 1; }\n\nhr.on-dark:before {\n  background-color: #454b52; }\n\nhr.on-dark:after {\n  background-color: #1d2329; }\n";
var HorizontalRule$2 = {"hrule":"HorizontalRule_hrule__3XaEt"};
var stylesheet$1=".HorizontalRule_hrule__3XaEt {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  padding: 0;\n  border: none;\n  position: relative;\n  min-height: 1px; }\n\n.HorizontalRule_hrule__3XaEt:before {\n  align-self: center;\n  background-color: #dcdfe3;\n  content: \"\";\n  display: flex;\n  height: 1px;\n  width: 100%;\n  position: absolute; }\n\n.HorizontalRule_hrule__3XaEt:after {\n  align-self: center;\n  background-color: #ffffff;\n  content: attr(aria-label);\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: center;\n  z-index: 1; }\n\nhr.on-dark:before {\n  background-color: #454b52; }\n\nhr.on-dark:after {\n  background-color: #1d2329; }\n";
styleInject(css_248z$1);

var HorizontalRule$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    hrule: hrule,
    'default': HorizontalRule$2,
    stylesheet: stylesheet$1
});

var styles$1 = /*@__PURE__*/getAugmentedNamespace(HorizontalRule$3);

var HorizontalRule_1 = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



var HorizontalRule = function (_a) {
    var centerWord = _a.centerWord, testId = _a.testId, onDark = _a.onDark, className = _a.className, ariaHidden = _a.ariaHidden;
    className = className ? className : "type-xs font-medium";
    var classes = onDark
        ? Join.join("on-dark", "color-ui-gray", className, styles$1.hrule)
        : Join.join("color-ui-black", className, styles$1.hrule);
    return (React__default.createElement("hr", { className: classes, "data-testid": testId, "aria-label": centerWord ? centerWord : undefined, "aria-hidden": ariaHidden ? ariaHidden : undefined }));
};
exports.default = HorizontalRule;
});

var HorizontalRule = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.default = HorizontalRule_1.default;
});

var HorizontalRule$1 = /*@__PURE__*/getDefaultExportFromCjs(HorizontalRule);

var content = {
    analytics: {},
    configuration: {},
    seo: {},
    pageinfo: {},
    customerVerificationModal: {
        "master": {
            "IconImagePath": "/idpassets/global/logos/firstnet/svg/firstnet-hrz-blk.svg",
            "heading": "Let’s check your FirstNet eligibility",
            "errorHeading": "I'm sorry we were not able to verify you",
            "errorMessage": "We will default you to a Non First Responder Plan. Feel free to retry verification if you think there was a mistake.",
            "copy": "We just need some info from you to make sure you qualify for FirstNet. Then, we’ll bring you back to shop.",
            "errorContinueCtaLabel": "Continue",
            "custVerificationCtaLabel": "See if I’m eligible",
            "custVerificationCtaURL": "https://www.firstnet.com/pilot",
            "custVerificationCtaURL_stage": "https://test-www.firstnet.com/pilot",
            "custVerificationCancelCtaLabel": "Cancel",
            "custVerificationCancelCtaURL": "/",
            "pilotTokenAPI": "/msapi/microsites-orch-nodems/v1/pilotToken/create",
            "custVerificationPilotTokenFN": "https://oidc.idp.flogin.att.com/mga/sps/authsvc?PolicyId=urn:ibm:security:authentication:asf:PilotAuth&targetURL=https://pilot-www.firstnet.com/signup/utf-auth-page",
            "custVerificationPilotTokenFN_stage": "https://oidc.stage.flogin.att.com/mga/sps/authsvc?PolicyId=urn:ibm:security:authentication:asf:PilotAuth&targetURL=https://test2-pilot-www.firstnet.com/signup/utf-auth-page",
            "signinUserURL": "/msapi/login/unauth/service/v1/haloc/do/login?host={hostname}&state=from=idp&client_id=m38538&is_passive=false&final_url=",
            "signinUserURL_Stage": "/msapi/login/unauth/service/v1/haloc/do/login?host={hostname}&state=from=idp&client_id=m36147&is_passive=false&final_url=",
            "loginReturnURL": "/msapi/login/unauth/service/v1/haloc/do/login?host={hostname}&state=from=idp&client_id=m38538&is_passive=true&final_url=",
            "loginReturnURL_stage": "/msapi/login/unauth/service/v1/haloc/do/login?host={hostname}&state=from=idp&client_id=m36147&is_passive=true&final_url=",
            "skipEligibility": {
                "master": {
                    "skipEligibilityCTALabel": "I already have a FirstNet ID",
                    "custFirstNetVerifySubheading": "Confirm your FirstNet ID",
                    "custFirstNetVerifyCopy": "We need more information from you to verify your identity.",
                    "custFirstNetIDVerifyLabel": "FirstNet ID",
                    "custLastNameVerifyLabel": "Last name",
                    "custFirstNetVerifyCTALabel": "Continue",
                    "continueWithoutFirstNetIdCTA": "Check eligibility instead",
                    "custIDNotFoundAlert": "Oops! We couldn’t find that FirstNet ID. Please try again.",
                    "systemFailureAlert": "We can't complete your order online right now. Please stop by an AT&T retail store or call FirstNet Support at 800.574.7000.",
                    "custIsLegacyAccountAlert": "We can't complete your order online right now. Please stop by an AT&T retail store or call FirstNet Support at 800.574.7000.",
                    "linkToPreviousScreenLabel": "Go back",
                    "variationID": "198dd877-acf8-3d30-9a23-bd1fba97c5a1"
                }
            },
            "skipEligibilityIdFound": {
                "master": {
                    "custActivateIdHeading": "Complete your FirstNet profile",
                    "custActivateIdCopy": "We found your FirstNet ID, but it looks like it’s not activated yet. Let’s finish setting it up.",
                    "custActivateIdCTA": "Continue",
                    "custFirstNetActivation": "https://test-profilemgt5.firstnet.att.com/icam-firstnet/confirm-user-id",
                    "custFirstNetActivation_stage": "https://test-profilemgt5.firstnet.att.com/icam-firstnet/confirm-user-id'",
                    "custLoginHeading": "Complete your FirstNet profile",
                    "custLoginCopy": "We found your FirstNet ID, but to be safe, we still need you to log in. To log in, you’ll enter the FirstNet ID and password that you created on FirstNet.com.",
                    "custLoginCTA": "Log in now",
                    "custActivateSuccessHeading": "We found your FirstNet ID ",
                    "custActivateSuccessCopy": "You’re all set to continue shopping.",
                    "custActivateSuccessContinueCTA": "Continue",
                    "variationID": "133343ad-e80a-3ff9-921e-c86d506231f0"
                }
            },
            "variationID": "cef3282e-9e61-3ed5-9902-3b1fc110da86"
        },
    },
};

var constants = {
    ENDPOINT_VERIFYAPI: '/msapi/onlinesalesorchestration/accounts-papi/v1/membership/verification',
    ENDPOINT_TIMEOUT: 20000
};

var initCustomerVerificationObject = '';
var customerVerificationObject = initCustomerVerificationObject;
var fetchCustomerVerificationUI = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, {
                    headers: {
                        'accept-encoding': 'gzip,deflate',
                    },
                }).then(function (data) {
                    return data
                        .json()
                        .then(function (response) {
                        var _a, _b;
                        if (response) {
                            var objLength = Object.keys((_b = (_a = response['idp-cms-feed']) === null || _a === void 0 ? void 0 : _a.firstnetverification) === null || _b === void 0 ? void 0 : _b.contentFragments).length;
                            if (objLength) {
                                customerVerificationObject = response['idp-cms-feed'].firstnetverification.contentFragments;
                                return customerVerificationObject;
                            }
                            else {
                                console.warn('fetchCustomerVerificationUI: response length is: ' + objLength);
                            }
                        }
                    })
                        .catch(function (err) { return console.error('fetchCustomerVerificationUI: fetch error: ' + err); });
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
function makeRequest(url, method) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var complete = false;
                    var timeout = setTimeout(function () {
                        complete = true;
                        console.error("VerifyApi: Request timed out. URL: " + url);
                        reject('timed out');
                    }, constants.ENDPOINT_TIMEOUT);
                    fetch(url, __assign({ mode: 'cors', headers: { 'Content-Type': 'application/json' } }, method))
                        .then(function (res) {
                        clearTimeout(timeout);
                        if (res && res.ok && !complete) {
                            return Promise.resolve(res.json());
                        }
                        reject(res.json());
                    })
                        .then(function (res) {
                        resolve(res);
                    });
                })];
        });
    });
}
var verifyFNApi = function (verifyRespData) { return __awaiter(void 0, void 0, void 0, function () {
    var verifyApiResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                verifyApiResponse = null;
                return [4 /*yield*/, makeRequest(constants.ENDPOINT_VERIFYAPI, {
                        method: 'POST',
                        body: JSON.stringify(verifyRespData),
                    })
                        .then(function (res) {
                        return Promise.resolve(res);
                    })
                        .catch(function () {
                        console.error("VerifyApi: Error. Verification API for firstnet customercall failed. ", constants.ENDPOINT_VERIFYAPI);
                    })];
            case 1:
                verifyApiResponse = _a.sent();
                return [2 /*return*/, verifyApiResponse];
        }
    });
}); };

var alert = "Alert_alert__1z5p8";
var padBxxxxS = "Alert_padBxxxxS__HYZj_";
var positionClose = "Alert_position-close__3J9QO";
var flexShrink = "Alert_flex-shrink__1fz36";
var onWhite = "Alert_on-white__1pX7c";
var hideSides = "Alert_hide-sides__uxSgI";
var padTxxxxSSm = "Alert_padTxxxxSSm__Yemfe";
var css_248z = "/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.Alert_alert__1z5p8 .Alert_padBxxxxS__HYZj_ {\n  padding-bottom: 2px; }\n\n.Alert_alert__1z5p8 .Alert_position-close__3J9QO {\n  top: -4px;\n  right: -4px; }\n\n.Alert_alert__1z5p8 .Alert_flex-shrink__1fz36 {\n  flex-shrink: 0; }\n\n@media (min-width: 0px) and (max-width: 767px) {\n  .Alert_alert__1z5p8 svg {\n    height: 24px !important;\n    min-width: 24px; }\n  .Alert_alert__1z5p8.Alert_on-white__1pX7c.Alert_hide-sides__uxSgI {\n    box-shadow: inset 0 1px 0 0 #dcdfe3, inset 0 -1px 0 0 #dcdfe3; }\n  .Alert_alert__1z5p8 .Alert_padTxxxxSSm__Yemfe {\n    padding-top: 2px; } }\n\n@media (min-width: 1025px) {\n  .Alert_alert__1z5p8 svg {\n    height: 32px !important; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .Alert_alert__1z5p8 svg {\n    height: 32px !important; } }\n";
var Alert$2 = {"alert":"Alert_alert__1z5p8","padBxxxxS":"Alert_padBxxxxS__HYZj_","position-close":"Alert_position-close__3J9QO","flex-shrink":"Alert_flex-shrink__1fz36","on-white":"Alert_on-white__1pX7c","hide-sides":"Alert_hide-sides__uxSgI","padTxxxxSSm":"Alert_padTxxxxSSm__Yemfe","positionClose":"Alert_position-close__3J9QO","flexShrink":"Alert_flex-shrink__1fz36","onWhite":"Alert_on-white__1pX7c","hideSides":"Alert_hide-sides__uxSgI"};
var stylesheet="/********************\n *  Common Spacers  *\n ********************/\n/****************\n *  Mathmatics  *\n ****************/\n/** Remove the unit from a passed number. */\n/** Get the square of the passed value. */\n/** Get the square root of the passed value. */\n/*******************\n *  Browser hacks  *\n *******************/\n/********************\n *  Apply Property  *\n ********************/\n/******************\n *  Tile Spacing  *\n ******************/\n/****************************\n *  Tile horizontal Margin  *\n ****************************/\n/*********************\n *  Standard Gutter  *\n *********************/\n/****************\n *  Tile width  *\n ****************/\n/******************\n *  Tile Padding  *\n ******************/\n/******************\n *  Repeat token  *\n ******************/\n/****************\n *  Grid items  *\n ****************/\n/*******************\n *  Media Queries  *\n *******************/\n/** Usually when we say mobile, we are really talking about mobile portrait. */\n.Alert_alert__1z5p8 .Alert_padBxxxxS__HYZj_ {\n  padding-bottom: 2px; }\n\n.Alert_alert__1z5p8 .Alert_position-close__3J9QO {\n  top: -4px;\n  right: -4px; }\n\n.Alert_alert__1z5p8 .Alert_flex-shrink__1fz36 {\n  flex-shrink: 0; }\n\n@media (min-width: 0px) and (max-width: 767px) {\n  .Alert_alert__1z5p8 svg {\n    height: 24px !important;\n    min-width: 24px; }\n  .Alert_alert__1z5p8.Alert_on-white__1pX7c.Alert_hide-sides__uxSgI {\n    box-shadow: inset 0 1px 0 0 #dcdfe3, inset 0 -1px 0 0 #dcdfe3; }\n  .Alert_alert__1z5p8 .Alert_padTxxxxSSm__Yemfe {\n    padding-top: 2px; } }\n\n@media (min-width: 1025px) {\n  .Alert_alert__1z5p8 svg {\n    height: 32px !important; } }\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .Alert_alert__1z5p8 svg {\n    height: 32px !important; } }\n";
styleInject(css_248z);

var Alert$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alert: alert,
    padBxxxxS: padBxxxxS,
    positionClose: positionClose,
    flexShrink: flexShrink,
    onWhite: onWhite,
    hideSides: hideSides,
    padTxxxxSSm: padTxxxxSSm,
    'default': Alert$2,
    stylesheet: stylesheet
});

var AlertProps = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultType = exports.TypeIcon = void 0;


exports.TypeIcon = {
    error: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Error", colorClass: "color-functional-dk-red", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm1 22h-2v-2h2zm0-4h-2V9h2z\"/></svg>" })),
    info: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Info", colorClass: "color-cobalt", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm1 22h-2V13h2zm0-12h-2V9h2z\"/></svg>" })),
    success: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Success", colorClass: "color-functional-dk-green", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M16 1a15 15 0 1015 15A15 15 0 0016 1zm-2.33 21.08l-5.38-5.37 1.42-1.42 4 4 8.62-8.62L23.71 12z\"/></svg>" })),
    warning: (React__default.createElement(IconSvg.default, { ariaHidden: false, ariaLabel: "Warning", colorClass: "color-functional-dk-orange", svgNodeStr: "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path class=\"svg-base\" d=\"M29.21 24.53L18.62 5.63a3 3 0 00-5.24 0L2.79 24.53A3 3 0 005.41 29h21.18a3 3 0 002.62-4.47zM17 24h-2v-2h2zm0-4h-2v-8h2z\"/></svg>" })),
};
exports.defaultType = "info";
});

var styles = /*@__PURE__*/getAugmentedNamespace(Alert$3);

var Alert_1 = createCommonjsModule(function (module, exports) {
var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (commonjsGlobal && commonjsGlobal.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });



var Alert = function (_a) {
    var children = _a.children, className = _a.className; _a.wrapperStyle; _a.wrapperClassName; var closeable = _a.closeable; _a.renderInList; var _c = _a.type, type = _c === void 0 ? AlertProps.defaultType : _c, _d = _a.icon, icon = _d === void 0 ? type && AlertProps.TypeIcon[type] : _d; _a.addBottomMargin; var _f = _a.hideSideBordersOnMobile, hideSideBordersOnMobile = _f === void 0 ? true : _f; _a.style; var name = _a.name; _a.position; var onClose = _a.onClose, _g = _a.onWhite, onWhite = _g === void 0 ? false : _g, testId = _a.testId;
    var _h = __read(React__default.useState({
        closed: false,
        render: true,
    }), 2), state = _h[0], setState = _h[1];
    state.closed; var render = state.render;
    var alertElement = React__default.useRef(null);
    var close = React__default.useCallback(function () {
        setState(__assign(__assign({}, state), { closed: true }));
        setState(__assign(__assign({}, state), { render: false }));
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose]);
    var classes = [styles.alert,
        "flex",
        "flex-items-top",
        "bg-ui-white pad-l-sm-lg pad-t-sm-lg pad-b-sm-lg pad-r-md-lg pad-t-xs-sm pad-b-xs-sm ",
        "rel",
        className];
    if (onWhite) {
        classes.push(styles.onWhite + " border-shadow");
    }
    if (hideSideBordersOnMobile) {
        classes.push(styles.hideSides);
    }
    return render ? (React__default.createElement("div", { className: classes.join(' '), "data-testid": testId, ref: alertElement },
        React__default.createElement("div", { className: "width-md-lg height-md-lg width-lg-md height-lg-md width-lg-sm height-lg-sm mar-r-xxs mar-r-none-sm " + styles.padBxxxxS + " pad-r-xxxs pad-none-sm mar-t-none-sm " + styles.flexShrink }, icon),
        React__default.createElement("div", { className: "type-base line-h-md color-ui-dark-gray mar-b-none mar-t-none-sm rel " + styles.padTxxxxSSm + " mar-l-xxxs mar-l-xxs-sm mar-t-xxxs" }, children),
        closeable && (React__default.createElement("button", { "aria-label": "Close " + (name || "alert"), name: "Close_" + (name || "alert"), className: styles.positionClose + " icon-close absolute color-ui-black", onClick: close })))) : null;
};
exports.default = Alert;
});

var Alert = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(Alert_1, exports);
__exportStar(AlertProps, exports);
var Alert_1$1 = Alert_1;
exports.default = Alert_1$1.default;
});

var Alert$1 = /*@__PURE__*/getDefaultExportFromCjs(Alert);

var CustomerVerification = function (props) {
    var _a = useState({
        feedData: content,
    }), CustomVerificationState = _a[0], CustomVerificationStateUpdate = _a[1];
    var _b = useState(props.isFailure || false), isFailure = _b[0]; _b[1];
    var _c = useState(false), disabled = _c[0], setDisabled = _c[1];
    var _d = useState(false), goBack = _d[0], setGoBack = _d[1];
    var _e = useState(true), hideLink = _e[0], setHideLink = _e[1];
    var _f = useState(false), onSkipVerification = _f[0], setOnSkipVerification = _f[1];
    var _g = useState(false), onVerifyActivation = _g[0], setOnVerifyActivation = _g[1];
    var _h = useState(false), onVerifyLogin = _h[0], setOnVerifyLogin = _h[1];
    var _j = useState(false), verifiedLoggedIn = _j[0], setVerifiedLoggedIn = _j[1];
    var _k = useState(''), firstNetId = _k[0], setfirstNetId = _k[1];
    var _l = useState(false), validateFirstNet = _l[0], setValidateFirstNet = _l[1];
    var _m = useState(''), lastName = _m[0], setLastName = _m[1];
    var _o = useState(false), validateLastName = _o[0], setValidateLastName = _o[1];
    var _p = useState(false), alert = _p[0], setAlert = _p[1];
    var _q = useState(false), isLegacyAlert = _q[0], setIsLegacyAlert = _q[1];
    var _r = useState(false), systemFailureAlertCustomer = _r[0], setsystemFailureAlertCustomer = _r[1];
    var _s = useState(false), alertToSkip = _s[0], setAlertToSkip = _s[1];
    var _t = useState({
        idNotFound: '',
        isLegacyFirstNet: '',
        isLoggedInMember: '',
        isValidMember: '',
        memberStatus: '',
        isExistingFirstNet: '',
    }), response = _t[0], setResponse = _t[1];
    var _u = useState(false), spin = _u[0], setspin = _u[1];
    useEffect(function () {
        handleVerify();
    }, [response]);
    var handleModalClose = function (e) {
        props.closeModal(e);
    };
    var isProd = window && window.location && window.location.host.indexOf('www.att.com') > -1;
    var isFinalStage = window && window.location && window.location.host.indexOf('finalstage.att.com') > -1;
    var hostname = window && window.location && window.location.origin;
    var handleVerification = function (e, ctaUrl) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            e.currentTarget.textContent || e.currentTarget.innerHTML;
            if ((!onSkipVerification && !isFailureCase)) {
                props.handleVerificationCta && props.handleVerificationCta(e, ctaUrl);
            }
            if (onVerifyActivation) {
                props.handleActivationCta && props.handleActivationCta(e, ctaUrl);
            }
            if (onVerifyLogin) {
                props.handleLoginCta && props.handleLoginCta(e, ctaUrl);
            }
            if (verifiedLoggedIn) {
                props.handleLoggedInCta && props.handleLoggedInCta(e, ctaUrl);
            }
            window.location.href = ctaUrl;
            return [2 /*return*/];
        });
    }); };
    var handleContinue = function (e) {
        props.handleFailureContinue(e);
    };
    var getContent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var orchFeedUrl, cmsFeedUrl, orchFeed, feed;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    orchFeedUrl = "/msapi/idp-content-orchestration/v1/idpcms/sales/firstnetverification";
                    cmsFeedUrl = "/idpcms/sales/prod/firstnetverification.cmsfeed.js";
                    return [4 /*yield*/, fetchCustomerVerificationUI(orchFeedUrl)];
                case 1:
                    orchFeed = _b.sent();
                    if (!orchFeed) return [3 /*break*/, 2];
                    (feed = orchFeed);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, fetchCustomerVerificationUI(cmsFeedUrl)];
                case 3:
                    (feed = _b.sent());
                    _b.label = 4;
                case 4:
                    if (feed !== undefined || null || '') {
                        CustomVerificationStateUpdate(__assign(__assign({}, CustomVerificationState), { feedData: feed }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var heading = props.heading
        ? props.heading
        : CustomVerificationState.feedData.customerVerificationModal.master.heading;
    var failureHeading = props.errorHeading
        ? props.errorHeading
        : CustomVerificationState.feedData.customerVerificationModal.master.errorHeading;
    var modalContent = props.copy
        ? props.copy
        : CustomVerificationState.feedData.customerVerificationModal.master.copy;
    var failureModalContent = props.errorMessage
        ? props.errorMessage
        : CustomVerificationState.feedData.customerVerificationModal.master.errorMessage;
    var verificationCtaLabel = CustomVerificationState.feedData.customerVerificationModal.master.custVerificationCtaLabel;
    var skipEligibilityCTALabel = props.skipEligibilityCTALabel
        ? props.skipEligibilityCTALabel
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .skipEligibilityCTALabel;
    var custFirstNetVerifyCTALabel = props.custFirstNetVerifyCTALabel
        ? props.custFirstNetVerifyCTALabel
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .custFirstNetVerifyCTALabel;
    var custActivateIdCTA = props.custActivateIdCTA
        ? props.custActivateIdCTA
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custActivateIdCTA;
    var custFirstNetVerifySubheading = props.custFirstNetVerifySubheading
        ? props.custFirstNetVerifySubheading
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .custFirstNetVerifySubheading;
    var custFirstNetVerifyCopy = props.custFirstNetVerifyCopy
        ? props.custFirstNetVerifyCopy
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .custFirstNetVerifyCopy;
    var custFirstNetIDVerifyLabel = props.custFirstNetIDVerifyLabel
        ? props.custFirstNetIDVerifyLabel
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .custFirstNetIDVerifyLabel;
    var custLastNameVerifyLabel = props.custLastNameVerifyLabel
        ? props.custLastNameVerifyLabel
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .custLastNameVerifyLabel;
    var continueWithoutFirstNetIdCTA = props.continueWithoutFirstNetIdCTA
        ? props.continueWithoutFirstNetIdCTA
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .continueWithoutFirstNetIdCTA;
    var custActivateIdHeading = props.custActivateIdHeading
        ? props.custActivateIdHeading
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custActivateIdHeading;
    var custActivateIdCopy = props.custActivateIdCopy
        ? props.custActivateIdCopy
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custActivateIdCopy;
    var custIDNotFoundAlert = props.custIDNotFoundAlert
        ? props.custIDNotFoundAlert
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master.custIDNotFoundAlert;
    var systemFailureAlert = props.systemFailureAlert
        ? props.systemFailureAlert
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master.systemFailureAlert;
    var custLoginHeading = props.custLoginHeading
        ? props.custLoginHeading
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custLoginHeading;
    var custLoginCopy = props.custLoginCopy
        ? props.custLoginCopy
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master.custLoginCopy;
    var custLoginCTA = props.custLoginCTA
        ? props.custLoginCTA
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master.custLoginCTA;
    var custIsLegacyAccountAlert = props.custIsLegacyAccountAlert
        ? props.custIsLegacyAccountAlert
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .custIsLegacyAccountAlert;
    var verifiedCustomerLoggedInHeading = props.verifiedCustomerLoggedInHeading
        ? props.verifiedCustomerLoggedInHeading
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custActivateSuccessHeading;
    var verifiedCustomerLoggedInContent = props.verifiedCustomerLoggedInContent
        ? props.verifiedCustomerLoggedInContent
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custActivateSuccessCopy;
    var verifiedCustomerLoggedInCTA = props.verifiedCustomerLoggedInCTA
        ? props.verifiedCustomerLoggedInCTA
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custActivateSuccessContinueCTA;
    var linkToPreviousScreenLabel = props.linkToPreviousScreenLabel
        ? props.linkToPreviousScreenLabel
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibility.master
            .linkToPreviousScreenLabel;
    var eligibility = !response.isExistingFirstNet ? 'eligible' : 'existing';
    var verificationCtaUrlFinal = '';
    var verificationCtaUrl = '';
    var activationCtaUrlFinal = '';
    var activationCtaUrl = '';
    var final_url = encodeURIComponent(props.applicationUrl);
    var loginurl = isProd || isFinalStage
        ? CustomVerificationState.feedData.customerVerificationModal.master.loginReturnURL
        : CustomVerificationState.feedData.customerVerificationModal.master.loginReturnURL_stage;
    var loginurlFinal = '';
    loginurl = loginurl.replace(/\{hostname\}/gi, window.location.host);
    loginurlFinal = hostname + loginurl + final_url + '&fnStatus=' + eligibility;
    var signinurl = isProd || isFinalStage
        ? CustomVerificationState.feedData.customerVerificationModal.master.signinUserURL
        : CustomVerificationState.feedData.customerVerificationModal.master.signinUserURL_Stage;
    var signinurlFinal = '';
    signinurl = signinurl.replace(/\{hostname\}/gi, window.location.host);
    signinurlFinal = hostname + signinurl + final_url + '&fnStatus=' + eligibility;
    var returnURL = encodeURIComponent(hostname + loginurl + final_url);
    verificationCtaUrlFinal = isProd
        ? CustomVerificationState.feedData.customerVerificationModal.master.custVerificationCtaURL
        : CustomVerificationState.feedData.customerVerificationModal.master.custVerificationCtaURL_stage;
    verificationCtaUrl = verificationCtaUrlFinal + '?returnURL=' + returnURL;
    activationCtaUrlFinal = isProd
        ? CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custFirstNetActivation
        : CustomVerificationState.feedData.customerVerificationModal.master.skipEligibilityIdFound.master
            .custFirstNetActivation_stage;
    activationCtaUrl = activationCtaUrlFinal + '?returnURL=' + returnURL;
    var cancelCtaLabel = CustomVerificationState.feedData.customerVerificationModal.master.custVerificationCancelCtaLabel;
    props.applicationUrl;
    var errorContinueCtaLabel = CustomVerificationState.feedData.customerVerificationModal.master.errorContinueCtaLabel;
    var isFailureCase = isFailure;
    var FNLogoUrl = CustomVerificationState.feedData.customerVerificationModal.master.IconImagePath;
    var FNLogoAlt = 'FirstNet logo';
    var FNLogoLabel = 'FirstNet Build with AT&T';
    var custIdEntry = {
        friendlyPageName: 'FirstNet ID Entry Modal Pg',
        url: '/buy/firstnetverification/identry/modal',
    };
    var custVerfiedLogin = {
        friendlyPageName: 'FirstNet Verification Status Modal Pg',
        url: '/buy/firstnetverification/status/modal',
    };
    var apiResponse = {
        Response: {
            idNotFound: response === null || response === void 0 ? void 0 : response.idNotFound,
            isLegacyFirstNet: response === null || response === void 0 ? void 0 : response.isLegacyFirstNet,
            isLoggedInMember: response === null || response === void 0 ? void 0 : response.isLoggedInMember,
            isValidMember: response === null || response === void 0 ? void 0 : response.isValidMember,
            memberStatus: response === null || response === void 0 ? void 0 : response.memberStatus,
            isExistingFirstNet: response === null || response === void 0 ? void 0 : response.isExistingFirstNet
        }
    };
    var verifyFirstNetID = function () {
        var data = {
            lastName: lastName,
            memberId: firstNetId,
        };
        verifyFNApi(data).then(function (res) {
            setResponse(res);
            if (props.handleVerifyApiResponse) {
                var responseData = {};
                responseData.errorType = ErrorTypes.SUCCESS_ADMIT;
                responseData.statusCode = 0;
                responseData.statusMessage = 'SUCCESS';
                responseData.linkName = custFirstNetVerifyCTALabel;
                responseData.successFlag = 1;
                props.handleVerifyApiResponse(responseData);
            }
            setspin(false);
        }).catch(function (e) {
            console.log('error', e);
        });
    };
    var handleVerify = function () {
        if (!response) {
            setsystemFailureAlertCustomer(true);
            setAlertToSkip(true);
            setAlert(false);
            setIsLegacyAlert(false);
            if (props.handleVerifyApiResponse) {
                var errorData = {};
                errorData.errorType = ErrorTypes.FAILURE_DATA;
                errorData.linkName = custFirstNetVerifyCTALabel;
                errorData.statusCode = -1;
                errorData.statusMessage = 'System Error';
                errorData.successFlag = 0;
                props.handleVerifyApiResponse(errorData);
            }
            props.modalPageLoadEvent && props.modalPageLoadEvent(custIdEntry);
        }
        if (response && response.isValidMember !== '' && !response.isValidMember) {
            setAlert(true);
            setIsLegacyAlert(false);
            setsystemFailureAlertCustomer(false);
            setAlertToSkip(true);
            if (props.handleVerifyApiResponse) {
                var errorData = {};
                errorData.errorType = ErrorTypes.FAILURE_DATA;
                errorData.linkName = custFirstNetIDVerifyLabel;
                errorData.statusMessage = 'FirstNet ID not found';
                errorData.successFlag = 0;
                props.handleVerifyApiResponse(errorData);
            }
            props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse);
            props.modalPageLoadEvent && props.modalPageLoadEvent(custIdEntry);
        }
        if (response && response.isValidMember !== '' && response.isLegacyFirstNet) {
            setIsLegacyAlert(true);
            setAlert(false);
            setsystemFailureAlertCustomer(false);
            setAlertToSkip(true);
            props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse);
            props.modalPageLoadEvent && props.modalPageLoadEvent(custIdEntry);
        }
        if (response && response.isValidMember !== '' && response.isValidMember && response.memberStatus !== 'Active') {
            setOnVerifyActivation(true);
            setIsLegacyAlert(false);
            setAlertToSkip(false);
            props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse);
            props.modalPageLoadEvent && props.modalPageLoadEvent(custVerfiedLogin);
        }
        if (response &&
            response.isValidMember !== '' &&
            response.isValidMember &&
            response.memberStatus === 'Active' &&
            !response.isLoggedInMember) {
            setOnVerifyLogin(true);
            setOnVerifyActivation(false);
            setIsLegacyAlert(false);
            setAlertToSkip(false);
            props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse);
            props.modalPageLoadEvent && props.modalPageLoadEvent(custVerfiedLogin);
        }
        if (response &&
            response.isValidMember !== '' &&
            response.isValidMember &&
            response.memberStatus === 'Active' &&
            response.isLoggedInMember) {
            setVerifiedLoggedIn(true);
            setOnVerifyLogin(false);
            setOnVerifyActivation(false);
            setIsLegacyAlert(false);
            setAlertToSkip(false);
            props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse);
            props.modalPageLoadEvent && props.modalPageLoadEvent(custVerfiedLogin);
        }
    };
    var alertUser = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "" + alertIcon },
            React.createElement(Alert$1, { onWhite: true, type: "warning" },
                React.createElement("p", { className: "font-regular type-xs color-ui-black " },
                    " ",
                    custIDNotFoundAlert)))));
    var customerIsLegacy = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "" + systemalertIcon },
            React.createElement(Alert$1, { onWhite: true, type: "warning" },
                React.createElement("p", { className: "font-regular type-xs color-ui-black " }, custIsLegacyAccountAlert)))));
    var systemFailureAlertUser = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "" + systemalertIcon },
            React.createElement(Alert$1, { onWhite: true, type: "warning" },
                React.createElement("p", { className: "font-regular type-xs color-ui-black " }, systemFailureAlert)))));
    var alertUserToSkip = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pad-t-xs" },
            React.createElement(HorizontalRule$1, null)),
        React.createElement("div", { className: "pad-t-xs text-center" },
            React.createElement(Button$1, { kind: "secondary", className: "" + verificationCtaClass, onClick: function (e) {
                    handleVerification(e, verificationCtaUrl);
                    props.onLinkClick && props.onLinkClick(continueWithoutFirstNetIdCTA);
                } }, continueWithoutFirstNetIdCTA))));
    useEffect(function () {
        getContent();
    }, []);
    return (React.createElement("div", { className: "" + verificationSimpleModelSize },
        FNLogoUrl && (React.createElement("div", { className: "" + firstNetImg },
            React.createElement("img", { src: FNLogoUrl, alt: FNLogoAlt, "aria-label": FNLogoLabel }))),
        !onVerifyActivation && !onVerifyLogin && !verifiedLoggedIn && !onSkipVerification && (React.createElement("div", { id: "dialog-heading", className: verificationModalHeading + " color-ui-black pad-t-xs" }, isFailureCase ? failureHeading : heading)),
        !onSkipVerification && !onVerifyActivation && !onVerifyLogin && !verifiedLoggedIn && (React.createElement("div", { className: [verificationModalContent + " color-ui-black font-regular type-sm mar-b-xs"].join(' '), dangerouslySetInnerHTML: {
                __html: purify.sanitize(isFailureCase ? failureModalContent : modalContent),
            } })),
        !onSkipVerification && isFailureCase && !onVerifyActivation && !onVerifyLogin && !verifiedLoggedIn && (React.createElement("div", { className: "pad-t-xs text-center" },
            React.createElement(Button$1, { kind: "primaryBlue", className: "" + verificationCtaClass, onClick: function (e) { return handleContinue(e); }, url: '#' }, errorContinueCtaLabel))),
        !onSkipVerification && !isFailureCase && !onVerifyActivation && !onVerifyLogin && !verifiedLoggedIn && (React.createElement("div", { className: "pad-t-xs text-center" },
            React.createElement(Button$1, { kind: "primaryBlue", className: "" + verificationCtaClass, onClick: function (e) {
                    setDisabled(true);
                    handleVerification(e, verificationCtaUrl);
                    props.onLinkClick && props.onLinkClick(verificationCtaLabel);
                } }, verificationCtaLabel))),
        props.showFirstNetVerifyCTA &&
            !onSkipVerification &&
            !isFailureCase &&
            !onVerifyActivation &&
            !onVerifyLogin && (React.createElement("div", { className: "pad-t-xs text-center" },
            React.createElement(Button$1, { kind: "secondary", className: "" + verificationCtaClass, onClick: function (e) {
                    setDisabled(true);
                    setOnSkipVerification(true);
                    setGoBack(false);
                    props.onLinkClick && props.onLinkClick(skipEligibilityCTALabel);
                    props.modalPageLoadEvent && props.modalPageLoadEvent(custIdEntry);
                } }, skipEligibilityCTALabel))),
        !onSkipVerification && !isFailureCase && !onVerifyActivation && !onVerifyLogin && !verifiedLoggedIn && (React.createElement("div", { className: "pad-t-xs text-center" },
            React.createElement(Link$1, { kind: "textUnderline", className: "solo " + verificationCancelCtaClass, onClick: handleModalClose }, cancelCtaLabel))),
        !goBack && onSkipVerification && !onVerifyActivation && !onVerifyLogin && !verifiedLoggedIn && (React.createElement("div", null,
            React.createElement("div", { className: "" + verificationModalSubHeading }, custFirstNetVerifySubheading),
            React.createElement("div", { className: [
                    verificationModalContent + " color-ui-black font-regular type-sm mar-b-xs",
                ].join(' ') }, custFirstNetVerifyCopy),
            alert && React.createElement("div", null, alertUser),
            isLegacyAlert && React.createElement("div", null, customerIsLegacy),
            systemFailureAlertCustomer && React.createElement("div", null, systemFailureAlertUser),
            React.createElement("div", { className: "pad-t-xxs" },
                React.createElement("div", { className: "pad-t-xxs " + textField + " " + label },
                    React.createElement(TextField$1, { id: "firstNetid", data: {
                            input: firstNetId,
                            name: 'firstnet-id',
                            labelText: custFirstNetIDVerifyLabel
                        }, events: {
                            onChange: function (e) {
                                var firstNetId = e.target.value;
                                setfirstNetId(firstNetId);
                                var emailPattern = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-][a-zA-Z0-9-]+\\.[a-zA-Z0-9-.][a-zA-Z0-9-.]+$');
                                if (!emailPattern.test(firstNetId)) {
                                    setValidateFirstNet(true);
                                }
                                else {
                                    setValidateFirstNet(false);
                                    setDisabled(true);
                                }
                            },
                        }, options: {
                            type: TextFieldProps.TextFieldType.EMAIL,
                            error: validateFirstNet ? true : false,
                            errorText: 'A FirstNet ID is required. Please enter an email address.',
                        } }))),
            React.createElement("div", { className: "pad-t-xs" },
                React.createElement("div", { className: "pad-t-xxs " + textField + " " + label },
                    React.createElement(TextField$1, { id: "last-name", data: {
                            input: lastName,
                            name: 'last-name',
                            labelText: custLastNameVerifyLabel
                        }, events: {
                            onChange: function (e) {
                                var lastName = e.target.value;
                                setLastName(lastName);
                                var lastNamePattern = new RegExp('^[a-zA-Z]*$');
                                if (!lastNamePattern.test(lastName)) {
                                    setValidateLastName(true);
                                    setDisabled(false);
                                }
                                else {
                                    setValidateLastName(false);
                                    setDisabled(true);
                                }
                            },
                        }, options: {
                            type: TextFieldProps.TextFieldType.TEXT,
                            error: validateLastName ? true : false,
                            errorText: 'A last name is required. Please enter text with no spaces, numbers, or special characters.',
                        } }))),
            React.createElement("div", { className: "pad-t-xs text-center" },
                React.createElement(Button$1, { kind: "primaryBlue", className: "" + verificationCtaClass, onClick: function (e) {
                        verifyFirstNetID();
                        setHideLink(false);
                        setDisabled(false);
                        setspin(true);
                        props.onLinkClick && props.onLinkClick(custFirstNetVerifyCTALabel);
                    }, disabled: (firstNetId.length > 0 && !validateFirstNet) && lastName.length > 0 && disabled ? false : true, spinner: spin }, custFirstNetVerifyCTALabel)),
            hideLink && (React.createElement("div", { className: "pad-t-xs text-center" },
                React.createElement(Link$1, { kind: "textUnderline", className: "solo " + verificationCancelCtaClass, onClick: function () {
                        setGoBack(true);
                        setOnSkipVerification(false);
                        setOnVerifyActivation(false);
                        setOnVerifyLogin(false);
                        props.onLinkClick && props.onLinkClick(linkToPreviousScreenLabel);
                    } }, linkToPreviousScreenLabel))),
            alertToSkip && React.createElement("div", null, alertUserToSkip))),
        onVerifyActivation && (React.createElement("div", { id: "dialog-heading", className: verificationModalHeading + " color-ui-black pad-t-xs" },
            custActivateIdHeading,
            React.createElement("div", { className: [
                    verificationModalContent + " color-ui-black font-regular type-sm mar-b-xs",
                ].join(' ') }, custActivateIdCopy),
            React.createElement("div", { className: "pad-t-xs text-center" },
                React.createElement(Button$1, { kind: "primaryBlue", className: "" + verificationCtaClass, onClick: function (e) {
                        setDisabled(true);
                        props.onLinkClick && props.onLinkClick(custActivateIdCTA);
                        props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse.Response.isValidMember);
                        handleVerification(e, activationCtaUrl);
                    } }, custActivateIdCTA)))),
        onVerifyLogin && (React.createElement("div", { id: "dialog-heading", className: verificationModalHeading + " color-ui-black pad-t-xs" },
            custLoginHeading,
            React.createElement("div", { className: [
                    verificationModalContent + " color-ui-black font-regular type-sm mar-b-xs",
                ].join(' ') }, custLoginCopy),
            React.createElement("div", { className: "pad-t-xs text-center" },
                React.createElement(Button$1, { kind: "primaryBlue", className: "" + verificationCtaClass, onClick: function (e) {
                        setDisabled(true);
                        props.onLinkClick && props.onLinkClick(custLoginCTA);
                        props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse.Response.isValidMember);
                        handleVerification(e, signinurlFinal);
                    } }, custLoginCTA)))),
        verifiedLoggedIn && (React.createElement("div", { id: "dialog-heading", className: verificationModalHeading + " color-ui-black pad-t-xs" },
            verifiedCustomerLoggedInHeading,
            React.createElement("div", { className: [
                    verificationModalContent + " color-ui-black font-regular type-sm mar-b-xs",
                ].join(' ') }, verifiedCustomerLoggedInContent),
            React.createElement("div", { className: "pad-t-xs text-center" },
                React.createElement(Button$1, { kind: "primaryBlue", className: "" + verificationCtaClass, onClick: function (e) {
                        setDisabled(true);
                        props.onLinkClick && props.onLinkClick(verifiedCustomerLoggedInCTA);
                        props.handleVerificationFirstNet && props.handleVerificationFirstNet(apiResponse.Response.isValidMember);
                        handleVerification(e, loginurlFinal);
                    } }, verifiedCustomerLoggedInCTA))))));
};

export { CustomerVerification };
//# sourceMappingURL=customer-verification-modal.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@sales/customer-verification-modal/dist/customer-verification-modal.es.js
// module id = 2357
// module chunks = 8